<div id="header-lp" *ngIf="isSlugOriginParam()">
  <!-- HEADER AFI SANTE -->
  <div
    class="header-afi-sante"
    *ngIf="currentHeader === 'afisante_affiliation'"
  >
    <img
      src="../../../../../../assets/img/AFI_SANTE_LOGO_2014_fondblanc-300x207.svg"
      alt="AFI Santé"
      srcset=""
      class="logo-afi-sante"
    />
    <img
      src="../../../../../../assets/img/une-marque-de-groupe-meilleurtaux.svg"
      alt="Une marque de groupe meilleurtaux"
      srcset=""
      class="marque-meilleurtaux"
    />
  </div>

  <!-- HEADER Mutuelle.com -->
  <div
    class="header-mutuelle-com"
    *ngIf="currentHeader === 'Mutuelle.com_affiliation'"
  >
    <img
      src="../../../../../../assets/img/logo-mutuelle_com-300x54.svg"
      alt="AFI Santé"
      srcset=""
      class="logo-afi-sante"
    />
    <img
      src="../../../../../../assets/img/une-marque-de-groupe-meilleurtaux.svg"
      alt="Une marque de groupe meilleurtaux"
      srcset=""
      class="marque-meilleurtaux"
    />
  </div>

  <!-- La Bonne Mutuelle -->
  <div
    class="header-la-bonne-mutuelle"
    *ngIf="currentHeader === 'labonnemutuelle_affiliation'"
  >
    <img
      src="../../../../../../assets/img/logo_LBM2019.svg"
      alt="AFI Santé"
      srcset=""
      class="logo-afi-sante"
    />
    <img
      src="../../../../../../assets/img/une-marque-de-groupe-meilleurtaux.svg"
      alt="Une marque de groupe meilleurtaux"
      srcset=""
      class="marque-meilleurtaux"
    />
  </div>

  <!-- Assurance et mutuelle -->
  <div
    class="header-la-assurance-et-mutuelle"
    *ngIf="currentHeader === 'assuranceetmutuelle_affiliation'"
  >
    <img
      src="../../../../../../assets/img/assurances-mutuelles-300x37.svg"
      alt="AFI Santé"
      srcset=""
      class="logo-afi-sante"
    />
    <img
      src="../../../../../../assets/img/une-marque-de-groupe-meilleurtaux.svg"
      alt="Une marque de groupe meilleurtaux"
      srcset=""
      class="marque-meilleurtaux"
    />
  </div>

  <!-- Mutuelle online -->
  <div
    class="header-mutuelle-online"
    *ngIf="currentHeader === 'mutuelleonline_affiliation'"
  >
    <img
      src="../../../../../../assets/img/MUTUELLEONLINE_LOGO-300x67.svg"
      alt="AFI Santé"
      srcset=""
      class="logo-afi-sante"
    />
    <img
      src="../../../../../../assets/img/une-marque-de-groupe-meilleurtaux.svg"
      alt="Une marque de groupe meilleurtaux"
      srcset=""
      class="marque-meilleurtaux"
    />
  </div>
</div>

<form [formGroup]="formGroup" class="form form-container" id="margin24">
  <div *ngIf="isParrainLink()" class="sub-container info-parrain">
    <div class="card">
      <div class="cardTitre">
        <div class="logo_parrain justify-self_center">
          <div class="">
            <img src="assets/img/img_recommandation.svg" alt="" />
          </div>
        </div>
        <div>
          <p class="info-text-parrain first">
            Votre parrain
            <span class="nom_parrain"
              >{{ civility_parrain == '1' ? 'Mme' : 'M' }}
              {{ nom_parrain | uppercase }} {{ prenoms_parrain }}</span
            >
            vous recommande
            <span class="mtx_recommandation">MEILLEURTAUX SANTE</span>
          </p>
          <p class="info-text-parrain last">
            Faites votre devis,
            <span class="compare_offer">
              comparez nos offres et recevez un chèque cadeau de
              <span class="oblique-strike">20€</span><sup>(1)</sup> !
            </span>
          </p>
        </div>
        <div class="justify-self_center right-text_parrainage">
          <p style="font-size: 17px; margin: 0">Opération coup</p>
          <p style="font-size: 17px">
            double:<strong style="font-size: 24px">40€</strong>
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="curentQuestion == 0" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-8"></div>
    </div>
    <div
      class="economie-text"
      style="text-align: center; margin-top: 15px; height: 35px"
      *ngIf="!verifyDateCreaEconomie('2024-04-26', '2024-06-28')"
    >
      <span class="text-color-orange" style="font-weight: 700"
        >399€ d'économies<sup>1</sup></span
      >
      en moyenne sur votre mutuelle santé
    </div>
    <div
      class="economie-text"
      style="text-align: center; margin-top: 15px; height: 35px"
      *ngIf="verifyDateCreaEconomie('2024-04-26', '2024-06-28')"
    >
      <span class="text-color-orange">1 mois offert<sup>1</sup> </span>
      sur votre contrat d'assurance santé !
    </div>
    <div class="divTitre">
      <h1 id="titre">Votre profil</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>

    <div class="progress">
      <div class="progress-bar-orange p-bar-8"></div>
    </div>

    <div class="card">
      <div class="cardTitre">
        <div id="question">
          <h2>Qui souhaitez-vous assurer ?</h2>
        </div>
      </div>
      <div class="blocChoix blocChoixCompo">
        <div class="cont-choix">
          <div class="choix" (click)="set_bouton_suivant_enabled()">
            <label>
              <input
                (click)="getCheckedValue('CompositionFamiliale', '1')"
                type="radio"
                name="CompositionFamiliale"
                class="card-input-element"
                [checked]="personne.compositionFamiliale == '1'"
              />

              <div class="panel panel-default card-input">
                <!-- <div class="check-icon">
                    <img src="assets/img/check.svg" alt="" />
                </div> -->
                <div class="panel-heading">
                  <svg
                    width="18"
                    height="43"
                    viewBox="0 0 18 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M5.10093 9.75954C4.17071 8.81191 3.59872 7.52363 3.59872 6.10433C3.59872 3.19335 6.00485 0.833495 8.97291 0.833495C11.941 0.833496 14.3471 3.19335 14.3471 6.10433C14.3471 7.52363 13.7751 8.81191 12.8449 9.75954C12.6028 10.0061 12.3365 10.2297 12.0496 10.4265C11.7936 10.6021 11.5211 10.7565 11.2351 10.8868C10.5475 11.2002 9.78103 11.3752 8.97291 11.3752C8.16476 11.3752 7.39827 11.2002 6.71068 10.8868C6.42464 10.7564 6.15224 10.6021 5.89619 10.4265C5.60935 10.2297 5.34301 10.0061 5.10093 9.75954ZM13.8118 12.7724C15.6505 13.1394 17.0342 14.7342 17.0342 16.646L17.0342 27.8465C17.0342 28.9382 16.1319 29.8231 15.0189 29.8231L13.6753 29.8231L13.6753 41.0236C13.6753 42.1152 12.773 43.0002 11.66 43.0002L6.28581 43.0002C5.17277 43.0002 4.27049 42.1152 4.27049 41.0236L4.27049 29.8231L2.92695 29.8231C1.81391 29.8231 0.91163 28.9382 0.91163 27.8465L0.911631 16.646C0.911631 14.7342 2.29527 13.1394 4.134 12.7724C4.39513 12.7202 4.66544 12.6929 4.94227 12.6929L5.89619 12.6929C6.85904 13.1271 7.91112 13.3516 8.97291 13.3519C10.0141 13.3523 11.0647 13.1371 12.0496 12.6929L13.0035 12.6929C13.2804 12.6929 13.5507 12.7202 13.8118 12.7724ZM12.6262 15.6262L13.0035 15.6262C13.6636 15.6262 14.1008 16.1362 14.1008 16.646L14.1008 26.8897L10.742 26.8897L10.742 40.0668L7.20383 40.0668L7.20383 26.8897L3.84496 26.8897L3.84497 16.646C3.84497 16.1362 4.28226 15.6262 4.94227 15.6262L5.3202 15.6262C7.6293 16.4888 10.2351 16.5209 12.6262 15.6262ZM6.53206 6.10433C6.53206 4.86682 7.57092 3.76683 8.97291 3.76683C10.3749 3.76683 11.4138 4.86682 11.4138 6.10433C11.4138 7.34184 10.3749 8.44183 8.97291 8.44183C7.57092 8.44183 6.53206 7.34184 6.53206 6.10433Z"
                      fill="#6d3311"
                    />
                  </svg>
                  <!-- <img src="assets/img/imgTunnel/adulte.svg" alt="" *ngIf="!checkIfAffiliation()"/> -->
                </div>
                <div class="panel-body txtFirst">Un adulte</div>
              </div>
            </label>
          </div>

          <div class="choix" (click)="set_bouton_suivant_enabled()">
            <label>
              <input
                (click)="getCheckedValue('CompositionFamiliale', '2')"
                type="radio"
                name="CompositionFamiliale"
                class="card-input-element"
                [checked]="personne.compositionFamiliale == '2'"
              />

              <div class="panel panel-default card-input">
                <!-- <div class="check-icon">
                    <img src="assets/img/check.svg" alt="" />
                </div> -->
                <div class="panel-heading">
                  <svg
                    width="31"
                    height="43"
                    viewBox="0 0 31 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.5117 18.2163C20.9515 17.5416 20.6147 16.6748 20.6147 15.7293C20.6147 13.5777 22.3589 11.8335 24.5105 11.8335C26.6621 11.8335 28.4063 13.5777 28.4063 15.7293C28.4063 16.6748 28.0695 17.5416 27.5093 18.2163C27.4841 18.2467 27.4585 18.2767 27.4324 18.3062C27.2274 18.5384 26.9953 18.746 26.7409 18.9239C26.5495 19.0578 26.3455 19.1749 26.1311 19.2731C25.6376 19.4992 25.0888 19.6252 24.5105 19.6252C23.9322 19.6252 23.3833 19.4992 22.8899 19.2731C22.6755 19.1749 22.4715 19.0578 22.2801 18.9239C22.0257 18.746 21.7936 18.5384 21.5886 18.3062C21.5625 18.2767 21.5369 18.2467 21.5117 18.2163ZM28.306 20.732C29.493 21.1034 30.3542 22.2116 30.3542 23.521L30.3542 31.7996C30.3542 32.6065 29.7002 33.2606 28.8933 33.2606L27.9194 33.2606L27.9194 41.5392C27.9194 42.3461 27.2653 43.0002 26.4584 43.0002L22.5626 43.0002C21.7557 43.0002 21.1016 42.3461 21.1016 41.5392L21.1016 33.2606L20.1277 33.2606C19.3208 33.2606 18.6668 32.6065 18.6668 31.7996L18.6668 23.521C18.6668 22.2116 19.528 21.1034 20.715 20.732C20.9909 20.6456 21.2843 20.5991 21.5886 20.5991L22.2801 20.5991C22.9781 20.9201 23.7408 21.086 24.5105 21.0862C25.2653 21.0865 26.0269 20.9275 26.7409 20.5991L27.4324 20.5991C27.7367 20.5991 28.0301 20.6456 28.306 20.732ZM27.2127 22.9825L27.4324 22.9825C27.7298 22.9825 27.9709 23.2235 27.9709 23.521L27.9709 30.8772L25.536 30.8772L25.536 40.6168L23.485 40.6168L23.485 30.8772L21.0501 30.8772L21.0501 23.521C21.0501 23.2235 21.2912 22.9825 21.5886 22.9825L21.8088 22.9825C23.5192 23.6202 25.4428 23.6436 27.2127 22.9825ZM22.998 15.7293C22.998 14.894 23.6752 14.2168 24.5105 14.2168C25.3458 14.2168 26.023 14.894 26.023 15.7293C26.023 16.5646 25.3458 17.2418 24.5105 17.2418C23.6752 17.2418 22.998 16.5646 22.998 15.7293Z"
                      fill="#6d3311"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.52257 9.75954C3.59234 8.81191 3.02036 7.52363 3.02036 6.10433C3.02036 3.19335 5.42648 0.833495 8.39454 0.833495C11.3626 0.833496 13.7687 3.19335 13.7687 6.10433C13.7687 7.52363 13.1967 8.81191 12.2665 9.75954C12.0244 10.0061 11.7581 10.2297 11.4713 10.4265C11.2152 10.6021 10.9428 10.7565 10.6567 10.8868C9.96913 11.2002 9.20266 11.3752 8.39454 11.3752C7.58639 11.3752 6.81991 11.2002 6.13231 10.8868C5.84627 10.7564 5.57388 10.6021 5.31782 10.4265C5.03098 10.2297 4.76464 10.0061 4.52257 9.75954ZM13.2334 12.7724C15.0722 13.1394 16.4558 14.7342 16.4558 16.646L16.4558 27.8465C16.4558 28.9382 15.5535 29.8231 14.4405 29.8231L13.0969 29.8231L13.0969 41.0236C13.0969 42.1152 12.1947 43.0002 11.0816 43.0002L5.70744 43.0002C4.5944 43.0002 3.69213 42.1152 3.69213 41.0236L3.69213 29.8231L2.34858 29.8231C1.23554 29.8231 0.333263 28.9382 0.333263 27.8465L0.333264 16.646C0.333264 14.7342 1.7169 13.1394 3.55563 12.7724C3.81676 12.7202 4.08707 12.6929 4.3639 12.6929L5.31782 12.6929C6.28068 13.1271 7.33275 13.3516 8.39454 13.3519C9.43577 13.3523 10.4863 13.1371 11.4713 12.6929L12.4252 12.6929C12.702 12.6929 12.9723 12.7202 13.2334 12.7724ZM12.0478 15.6262L12.4252 15.6262C13.0852 15.6262 13.5225 16.1362 13.5225 16.646L13.5225 26.8897L10.1636 26.8897L10.1636 40.0668L6.62546 40.0668L6.62546 26.8897L3.2666 26.8897L3.2666 16.646C3.2666 16.1362 3.70389 15.6262 4.3639 15.6262L4.74183 15.6262C7.05093 16.4888 9.65671 16.5209 12.0478 15.6262ZM5.95369 6.10433C5.95369 4.86682 6.99256 3.76683 8.39454 3.76683C9.79652 3.76683 10.8354 4.86682 10.8354 6.10433C10.8354 7.34184 9.79652 8.44183 8.39454 8.44183C6.99256 8.44183 5.95369 7.34184 5.95369 6.10433Z"
                      fill="#6d3311"
                    />
                  </svg>
                  <!-- <img src="assets/img/imgTunnel/adulteEnfant.svg" alt=""/> -->
                </div>
                <div class="panel-body txtFirst">Un adulte + enfant(s)</div>
              </div>
            </label>
          </div>
        </div>
        <div class="cont-choix">
          <div class="choix" (click)="set_bouton_suivant_enabled()">
            <label>
              <input
                (click)="getCheckedValue('CompositionFamiliale', '3')"
                type="radio"
                name="CompositionFamiliale"
                class="card-input-element"
                [checked]="personne.compositionFamiliale == '3'"
              />

              <div class="panel panel-default card-input">
                <!-- <div class="check-icon">
                    <img src="assets/img/check.svg" alt="" />
                </div> -->
                <div class="panel-heading">
                  <svg
                    width="39"
                    height="43"
                    viewBox="0 0 39 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M26.1891 8.92604C25.2588 7.97842 24.6869 6.69013 24.6869 5.27083C24.6869 2.35985 27.093 9.43134e-07 30.061 1.20261e-06C33.0291 1.46209e-06 35.4352 2.35985 35.4352 5.27084C35.4352 6.69013 34.8632 7.97842 33.933 8.92604C33.6909 9.17265 33.4246 9.39619 33.1378 9.59296C32.8817 9.76863 32.6093 9.92297 32.3232 10.0533C31.6356 10.3667 30.8692 10.5417 30.061 10.5417C29.2529 10.5417 28.4864 10.3667 27.7988 10.0533C27.5128 9.92295 27.2404 9.76862 26.9843 9.59296C26.6975 9.39619 26.4311 9.17265 26.1891 8.92604ZM34.8999 11.9389C36.7387 12.306 38.1223 13.9007 38.1223 15.8125L38.1223 27.013C38.1223 28.1047 37.22 28.9896 36.107 28.9896L34.7634 28.9896L34.7634 40.1901C34.7634 41.2817 33.8612 42.1667 32.7481 42.1667L27.3739 42.1667C26.2609 42.1667 25.3586 41.2817 25.3586 40.1901L25.3586 28.9896L24.0151 28.9896C22.902 28.9896 21.9998 28.1047 21.9998 27.013L21.9998 15.8125C21.9998 13.9007 23.3834 12.306 25.2221 11.9389C25.4833 11.8867 25.7536 11.8594 26.0304 11.8594L26.9843 11.8594C27.9472 12.2936 28.9993 12.5181 30.061 12.5184C31.1023 12.5188 32.1528 12.3036 33.1378 11.8594L34.0917 11.8594C34.3685 11.8594 34.6388 11.8867 34.8999 11.9389ZM33.7143 14.7927L34.0917 14.7927C34.7517 14.7927 35.189 15.3027 35.189 15.8125L35.189 26.0563L31.8301 26.0563L31.8301 39.2333L28.292 39.2333L28.292 26.0563L24.9331 26.0563L24.9331 15.8125C24.9331 15.3027 25.3704 14.7927 26.0304 14.7927L26.4083 14.7927C28.7174 15.6553 31.3232 15.6874 33.7143 14.7927ZM27.6202 5.27083C27.6202 4.03332 28.6591 2.93333 30.061 2.93333C31.463 2.93333 32.5019 4.03332 32.5019 5.27083C32.5019 6.50835 31.463 7.60833 30.061 7.60833C28.6591 7.60833 27.6202 6.50834 27.6202 5.27083Z"
                      fill="#6d3311"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.7074 29.169L15.7543 13.3565C15.6474 12.9289 15.4006 12.5493 15.0531 12.278C14.9064 12.1634 14.7452 12.0709 14.5748 12.0023C14.3417 11.9085 14.0914 11.8594 13.8368 11.8594H12.9012C11.9569 12.2936 10.925 12.5181 9.88365 12.5184C8.86244 12.5188 7.83208 12.3036 6.86609 11.8594H5.93052C5.67592 11.8594 5.42555 11.9085 5.19251 12.0023C5.02207 12.0709 4.86091 12.1634 4.71414 12.278C4.36671 12.5493 4.11992 12.9289 4.01301 13.3565L0.0598836 29.169C-0.25159 30.4148 0.691231 31.625 1.9774 31.625H6.58937V40.1901C6.58937 41.2817 7.4743 42.1667 8.56594 42.1667H11.2014C12.293 42.1667 13.1779 41.2817 13.1779 40.1901V31.625H17.7899C19.0739 31.625 20.0194 30.4167 19.7074 29.169ZM6.08613 8.92604C6.32356 9.17265 6.58478 9.39619 6.86609 9.59296C7.12502 9.77407 7.40097 9.93251 7.69107 10.0654C8.35871 10.3712 9.10127 10.5417 9.88365 10.5417C10.666 10.5417 11.4086 10.3712 12.0763 10.0654C12.3664 9.93249 12.6423 9.77406 12.9012 9.59296C13.1825 9.39619 13.4437 9.17265 13.6812 8.92604C14.5935 7.97842 15.1545 6.69013 15.1545 5.27084C15.1545 2.35985 12.7946 1.90735e-06 9.88365 1.90735e-06C6.97266 1.90735e-06 4.61281 2.35985 4.61281 5.27084C4.61281 6.69013 5.1738 7.97842 6.08613 8.92604ZM6.645 14.923L3.20284 28.6917H9.52271V39.2333H10.2446V28.6917H16.5645L13.1222 14.9226C11.0555 15.6165 8.77567 15.6396 6.645 14.923ZM12.2211 5.27084C12.2211 3.97989 11.1746 2.93334 9.88365 2.93334C8.5927 2.93334 7.54615 3.97989 7.54615 5.27084C7.54615 6.56178 8.5927 7.60834 9.88365 7.60834C11.1746 7.60834 12.2211 6.56178 12.2211 5.27084Z"
                      fill="#6d3311"
                    />
                  </svg>
                  <!-- <img src="assets/img/imgTunnel/couple.svg" alt=""/> -->
                </div>
                <div class="panel-body txtFirst">Un couple</div>
              </div>
            </label>
          </div>

          <div class="choix" (click)="set_bouton_suivant_enabled()">
            <label>
              <input
                (click)="getCheckedValue('CompositionFamiliale', '4')"
                type="radio"
                name="CompositionFamiliale"
                class="card-input-element"
                [checked]="personne.compositionFamiliale == '4'"
              />
              <div class="panel panel-default card-input">
                <!-- <div class="check-icon">
                    <img src="assets/img/check.svg" alt="" />
                </div> -->
                <div class="panel-heading">
                  <svg
                    width="43"
                    height="43"
                    viewBox="0 0 43 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.6893 9.75954C19.7591 8.81191 19.1871 7.52363 19.1871 6.10433C19.1871 3.19335 21.5932 0.833495 24.5613 0.833495C27.5293 0.833496 29.9355 3.19335 29.9355 6.10433C29.9355 7.52363 29.3635 8.81191 28.4333 9.75954C28.1912 10.0061 27.9248 10.2297 27.638 10.4265C27.3819 10.6021 27.1095 10.7565 26.8235 10.8868C26.1359 11.2002 25.3694 11.3752 24.5613 11.3752C23.7531 11.3752 22.9867 11.2002 22.2991 10.8868C22.013 10.7564 21.7406 10.6021 21.4846 10.4265C21.1977 10.2297 20.9314 10.0061 20.6893 9.75954ZM29.4002 12.7724C31.2389 13.1394 32.6226 14.7342 32.6226 16.646L32.6226 27.8465C32.6226 28.9382 31.7203 29.8231 30.6072 29.8231L29.2637 29.8231L29.2637 41.0236C29.2637 42.1152 28.3614 43.0002 27.2484 43.0002L21.8742 43.0002C20.7611 43.0002 19.8589 42.1152 19.8589 41.0236L19.8589 29.8231L18.5153 29.8231C17.4023 29.8231 16.5 28.9382 16.5 27.8465L16.5 16.646C16.5 14.7342 17.8836 13.1394 19.7224 12.7724C19.9835 12.7202 20.2538 12.6929 20.5306 12.6929L21.4846 12.6929C22.4474 13.1271 23.4995 13.3516 24.5613 13.3519C25.6025 13.3523 26.6531 13.1371 27.638 12.6929L28.5919 12.6929C28.8687 12.6929 29.1391 12.7202 29.4002 12.7724ZM28.2146 15.6262L28.5919 15.6262C29.2519 15.6262 29.6892 16.1362 29.6892 16.646L29.6892 26.8897L26.3304 26.8897L26.3304 40.0668L22.7922 40.0668L22.7922 26.8897L19.4333 26.8897L19.4333 16.646C19.4333 16.1362 19.8706 15.6262 20.5306 15.6262L20.9086 15.6262C23.2177 16.4888 25.8235 16.5209 28.2146 15.6262ZM22.1204 6.10433C22.1204 4.86682 23.1593 3.76683 24.5613 3.76683C25.9633 3.76683 27.0021 4.86682 27.0021 6.10433C27.0021 7.34184 25.9633 8.44183 24.5613 8.44183C23.1593 8.44183 22.1204 7.34184 22.1204 6.10433Z"
                      fill="#6d3311"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M34.0117 18.2163C33.4515 17.5416 33.1147 16.6748 33.1147 15.7293C33.1147 13.5777 34.8589 11.8335 37.0105 11.8335C39.1621 11.8335 40.9063 13.5777 40.9063 15.7293C40.9063 16.6748 40.5695 17.5416 40.0093 18.2163C39.9841 18.2467 39.9585 18.2767 39.9324 18.3062C39.7274 18.5384 39.4953 18.746 39.2409 18.9239C39.0495 19.0578 38.8455 19.1749 38.6311 19.2731C38.1376 19.4992 37.5888 19.6252 37.0105 19.6252C36.4322 19.6252 35.8833 19.4992 35.3899 19.2731C35.1755 19.1749 34.9715 19.0578 34.7801 18.9239C34.5257 18.746 34.2936 18.5384 34.0886 18.3062C34.0625 18.2767 34.0369 18.2467 34.0117 18.2163ZM40.806 20.732C41.993 21.1034 42.8542 22.2116 42.8542 23.521L42.8542 31.7996C42.8542 32.6065 42.2002 33.2606 41.3933 33.2606L40.4194 33.2606L40.4194 41.5392C40.4194 42.3461 39.7653 43.0002 38.9584 43.0002L35.0626 43.0002C34.2557 43.0002 33.6016 42.3461 33.6016 41.5392L33.6016 33.2606L32.6277 33.2606C31.8208 33.2606 31.1668 32.6065 31.1668 31.7996L31.1668 23.521C31.1668 22.2116 32.028 21.1034 33.215 20.732C33.4909 20.6456 33.7843 20.5991 34.0886 20.5991L34.7801 20.5991C35.4781 20.9201 36.2408 21.086 37.0105 21.0862C37.7653 21.0865 38.5269 20.9275 39.2409 20.5991L39.9324 20.5991C40.2367 20.5991 40.5301 20.6456 40.806 20.732ZM39.7127 22.9825L39.9324 22.9825C40.2298 22.9825 40.4709 23.2235 40.4709 23.521L40.4709 30.8772L38.036 30.8772L38.036 40.6168L35.985 40.6168L35.985 30.8772L33.5501 30.8772L33.5501 23.521C33.5501 23.2235 33.7912 22.9825 34.0886 22.9825L34.3088 22.9825C36.0192 23.6202 37.9428 23.6436 39.7127 22.9825ZM35.498 15.7293C35.498 14.894 36.1752 14.2168 37.0105 14.2168C37.8458 14.2168 38.523 14.894 38.523 15.7293C38.523 16.5646 37.8458 17.2418 37.0105 17.2418C36.1752 17.2418 35.498 16.5646 35.498 15.7293Z"
                      fill="#6d3311"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M19.7074 30.0025L15.7543 14.19C15.6474 13.7624 15.4006 13.3828 15.0531 13.1115C14.9064 12.9969 14.7452 12.9044 14.5748 12.8358C14.3417 12.742 14.0914 12.6929 13.8368 12.6929H12.9012C11.9569 13.1271 10.925 13.3516 9.88365 13.3519C8.86244 13.3523 7.83208 13.1371 6.86609 12.6929H5.93052C5.67592 12.6929 5.42555 12.742 5.19251 12.8358C5.02207 12.9044 4.86091 12.9969 4.71414 13.1115C4.36671 13.3828 4.11992 13.7624 4.01301 14.19L0.0598836 30.0025C-0.25159 31.2483 0.691231 32.4585 1.9774 32.4585H6.58937V41.0236C6.58937 42.1152 7.4743 43.0002 8.56594 43.0002H11.2014C12.293 43.0002 13.1779 42.1152 13.1779 41.0236V32.4585H17.7899C19.0739 32.4585 20.0194 31.2502 19.7074 30.0025ZM6.08613 9.75954C6.32356 10.0061 6.58478 10.2297 6.86609 10.4265C7.12502 10.6076 7.40097 10.766 7.69107 10.8989C8.35871 11.2047 9.10127 11.3752 9.88365 11.3752C10.666 11.3752 11.4086 11.2047 12.0763 10.8989C12.3664 10.766 12.6423 10.6076 12.9012 10.4265C13.1825 10.2297 13.4437 10.0061 13.6812 9.75954C14.5935 8.81191 15.1545 7.52363 15.1545 6.10433C15.1545 3.19335 12.7946 0.833496 9.88365 0.833496C6.97266 0.833496 4.61281 3.19335 4.61281 6.10433C4.61281 7.52363 5.1738 8.81191 6.08613 9.75954ZM6.645 15.7565L3.20284 29.5252H9.52271V40.0668H10.2446V29.5252H16.5645L13.1222 15.7561C11.0555 16.45 8.77567 16.4731 6.645 15.7565ZM12.2211 6.10433C12.2211 4.81338 11.1746 3.76683 9.88365 3.76683C8.5927 3.76683 7.54615 4.81338 7.54615 6.10433C7.54615 7.39528 8.5927 8.44183 9.88365 8.44183C11.1746 8.44183 12.2211 7.39528 12.2211 6.10433Z"
                      fill="#6d3311"
                    />
                  </svg>
                  <!-- <img src="assets/img/imgTunnel/famille.svg" alt=""/> -->
                </div>
                <div class="panel-body txtFirst">Un couple + enfant(s)</div>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="displayBtnQ0" class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNext01"></ng-container>
      </div>

      <div class="footer-assuree">
        <div class="trustploit-horizontale">
          <div class="trustplot-div">
            <div class="five-star">
              <svg
                role="img"
                aria-labelledby="starRating"
                viewBox="0 0 251 46"
                xmlns="http://www.w3.org/2000/svg"
                style="
                  position: relative;
                  height: 100%;
                  width: 100%;
                  left: 0;
                  top: 0;
                "
              >
                <defs>
                  <style>
                    .tp-star__canvas,
                    .tp-star__canvas--half {
                      fill: #00b67a;
                    }
                  </style>
                </defs>
                <title id="starRating" lang="en">
                  4.8 out of five star rating on Trustpilot
                </title>
                <g class="tp-star">
                  <path
                    class="tp-star__canvas"
                    fill="#dcdce6"
                    d="M0 46.330002h46.375586V0H0z"
                  ></path>
                  <path
                    class="tp-star__shape"
                    d="M39.533936 19.711433L13.230239 38.80065l3.838216-11.797827L7.02115 19.711433h12.418975l3.837417-11.798624 3.837418 11.798624h12.418975zM23.2785 31.510075l7.183595-1.509576 2.862114 8.800152L23.2785 31.510075z"
                    fill="#FFF"
                  ></path>
                </g>
                <g class="tp-star">
                  <path
                    class="tp-star__canvas"
                    fill="#dcdce6"
                    d="M51.24816 46.330002h46.375587V0H51.248161z"
                  ></path>
                  <path
                    class="tp-star__canvas--half"
                    fill="#dcdce6"
                    d="M51.24816 46.330002h23.187793V0H51.248161z"
                  ></path>
                  <path
                    class="tp-star__shape"
                    d="M74.990978 31.32991L81.150908 30 84 39l-9.660206-7.202786L64.30279 39l3.895636-11.840666L58 19.841466h12.605577L74.499595 8l3.895637 11.841466H91L74.990978 31.329909z"
                    fill="#FFF"
                  ></path>
                </g>
                <g class="tp-star">
                  <path
                    class="tp-star__canvas"
                    fill="#dcdce6"
                    d="M102.532209 46.330002h46.375586V0h-46.375586z"
                  ></path>
                  <path
                    class="tp-star__canvas--half"
                    fill="#dcdce6"
                    d="M102.532209 46.330002h23.187793V0h-23.187793z"
                  ></path>
                  <path
                    class="tp-star__shape"
                    d="M142.066994 19.711433L115.763298 38.80065l3.838215-11.797827-10.047304-7.291391h12.418975l3.837418-11.798624 3.837417 11.798624h12.418975zM125.81156 31.510075l7.183595-1.509576 2.862113 8.800152-10.045708-7.290576z"
                    fill="#FFF"
                  ></path>
                </g>
                <g class="tp-star">
                  <path
                    class="tp-star__canvas"
                    fill="#dcdce6"
                    d="M153.815458 46.330002h46.375586V0h-46.375586z"
                  ></path>
                  <path
                    class="tp-star__canvas--half"
                    fill="#dcdce6"
                    d="M153.815458 46.330002h23.187793V0h-23.187793z"
                  ></path>
                  <path
                    class="tp-star__shape"
                    d="M193.348355 19.711433L167.045457 38.80065l3.837417-11.797827-10.047303-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418974zM177.09292 31.510075l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                    fill="#FFF"
                  ></path>
                </g>
                <g class="tp-star">
                  <path
                    class="tp-star__canvas"
                    fill="#dcdce6"
                    d="M205.064416 46.330002h46.375587V0h-46.375587z"
                  ></path>
                  <path
                    class="tp-star__canvas--half"
                    fill="#dcdce6"
                    d="M205.064416 46.330002h23.187793V0h-23.187793z"
                  ></path>
                  <path
                    class="tp-star__shape"
                    d="M244.597022 19.711433l-26.3029 19.089218 3.837419-11.797827-10.047304-7.291391h12.418974l3.837418-11.798624 3.837418 11.798624h12.418975zm-16.255436 11.798642l7.183595-1.509576 2.862114 8.800152-10.045709-7.290576z"
                    fill="#FFF"
                  ></path>
                </g>
              </svg>
              <!-- <img src="assets/img/trustpilot-five-start.svg" alt="" /> -->
            </div>
            <div class="on-star-and-text">
              <svg
                role="img"
                aria-labelledby="trustpilotLogo"
                viewBox="0 0 126 31"
                xmlns="http://www.w3.org/2000/svg"
                style="
                  position: relative;
                  height: 100%;
                  width: 100%;
                  left: 0;
                  top: 0;
                "
              >
                <defs>
                  <style>
                    .tp-logo__text {
                      font-weight: 600;
                    }
                  </style>
                </defs>
                <title id="trustpilotLogo">Trustpilot</title>
                <path
                  class="tp-logo__text"
                  stroke-width="2%"
                  d="M33.074774 11.07005H45.81806v2.364196h-5.010656v13.290316h-2.755306V13.434246h-4.988435V11.07005h.01111zm12.198892 4.319629h2.355341v2.187433h.04444c.077771-.309334.222203-.60762.433295-.894859.211092-.287239.466624-.56343.766597-.79543.299972-.243048.633276-.430858.999909-.585525.366633-.14362.744377-.220953 1.12212-.220953.288863 0 .499955.011047.611056.022095.1111.011048.222202.033143.344413.04419v2.408387c-.177762-.033143-.355523-.055238-.544395-.077333-.188872-.022096-.366633-.033143-.544395-.033143-.422184 0-.822148.08838-1.199891.254096-.377744.165714-.699936.41981-.977689.740192-.277753.331429-.499955.729144-.666606 1.21524-.166652.486097-.244422 1.03848-.244422 1.668195v5.39125h-2.510883V15.38968h.01111zm18.220567 11.334883H61.02779v-1.579813h-.04444c-.311083.574477-.766597 1.02743-1.377653 1.369908-.611055.342477-1.233221.51924-1.866497.51924-1.499864 0-2.588654-.364573-3.25526-1.104765-.666606-.740193-.999909-1.856005-.999909-3.347437V15.38968h2.510883v6.948968c0 .994288.188872 1.701337.577725 2.1101.377744.408763.922139.618668 1.610965.618668.533285 0 .96658-.077333 1.322102-.243048.355524-.165714.644386-.37562.855478-.65181.222202-.265144.377744-.596574.477735-.972194.09999-.37562.144431-.784382.144431-1.226288v-6.573349h2.510883v11.323836zm4.27739-3.634675c.07777.729144.355522 1.237336.833257 1.535623.488844.287238 1.06657.441905 1.744286.441905.233312 0 .499954-.022095.799927-.055238.299973-.033143.588836-.110476.844368-.209905.266642-.099429.477734-.254096.655496-.452954.166652-.198857.244422-.452953.233312-.773335-.01111-.320381-.133321-.585525-.355523-.784382-.222202-.209906-.499955-.364573-.844368-.497144-.344413-.121525-.733267-.232-1.17767-.320382-.444405-.088381-.888809-.18781-1.344323-.287239-.466624-.099429-.922138-.232-1.355432-.37562-.433294-.14362-.822148-.342477-1.166561-.596573-.344413-.243048-.622166-.56343-.822148-.950097-.211092-.386668-.311083-.861716-.311083-1.436194 0-.618668.155542-1.12686.455515-1.54667.299972-.41981.688826-.75124 1.14434-1.005336.466624-.254095.97769-.430858 1.544304-.541334.566615-.099429 1.11101-.154667 1.622075-.154667.588836 0 1.15545.066286 1.688736.18781.533285.121524 1.02213.320381 1.455423.60762.433294.276191.788817.640764 1.07768 1.08267.288863.441905.466624.98324.544395 1.612955h-2.621984c-.122211-.596572-.388854-1.005335-.822148-1.204193-.433294-.209905-.933248-.309334-1.488753-.309334-.177762 0-.388854.011048-.633276.04419-.244422.033144-.466624.088382-.688826.165715-.211092.077334-.388854.198858-.544395.353525-.144432.154667-.222203.353525-.222203.60762 0 .309335.111101.552383.322193.740193.211092.18781.488845.342477.833258.475048.344413.121524.733267.232 1.177671.320382.444404.088381.899918.18781 1.366542.287239.455515.099429.899919.232 1.344323.37562.444404.14362.833257.342477 1.17767.596573.344414.254095.622166.56343.833258.93905.211092.37562.322193.850668.322193 1.40305 0 .673906-.155541 1.237336-.466624 1.712385-.311083.464001-.711047.850669-1.199891 1.137907-.488845.28724-1.04435.508192-1.644295.640764-.599946.132572-1.199891.198857-1.788727.198857-.722156 0-1.388762-.077333-1.999818-.243048-.611056-.165714-1.14434-.408763-1.588745-.729144-.444404-.33143-.799927-.740192-1.05546-1.226289-.255532-.486096-.388853-1.071621-.411073-1.745528h2.533103v-.022095zm8.288135-7.700208h1.899828v-3.402675h2.510883v3.402675h2.26646v1.867052h-2.26646v6.054109c0 .265143.01111.486096.03333.684954.02222.18781.07777.353524.155542.486096.07777.132572.199981.232.366633.298287.166651.066285.377743.099428.666606.099428.177762 0 .355523 0 .533285-.011047.177762-.011048.355523-.033143.533285-.077334v1.933338c-.277753.033143-.555505.055238-.811038.088381-.266642.033143-.533285.04419-.811037.04419-.666606 0-1.199891-.066285-1.599855-.18781-.399963-.121523-.722156-.309333-.944358-.552381-.233313-.243049-.377744-.541335-.466625-.905907-.07777-.364573-.13332-.784383-.144431-1.248384v-6.683825h-1.899827v-1.889147h-.02222zm8.454788 0h2.377562V16.9253h.04444c.355523-.662858.844368-1.12686 1.477644-1.414098.633276-.287239 1.310992-.430858 2.055369-.430858.899918 0 1.677625.154667 2.344231.475048.666606.309335 1.222111.740193 1.666515 1.292575.444405.552382.766597 1.193145.9888 1.92229.222202.729145.333303 1.513527.333303 2.3421 0 .762288-.099991 1.50248-.299973 2.20953-.199982.718096-.499955 1.347812-.899918 1.900194-.399964.552383-.911029.98324-1.533194 1.31467-.622166.33143-1.344323.497144-2.18869.497144-.366634 0-.733267-.033143-1.0999-.099429-.366634-.066286-.722157-.176762-1.05546-.320381-.333303-.14362-.655496-.33143-.933249-.56343-.288863-.232-.522175-.497144-.722157-.79543h-.04444v5.656393h-2.510883V15.38968zm8.77698 5.67849c0-.508193-.06666-1.005337-.199981-1.491433-.133321-.486096-.333303-.905907-.599946-1.281527-.266642-.37562-.599945-.673906-.988799-.894859-.399963-.220953-.855478-.342477-1.366542-.342477-1.05546 0-1.855387.364572-2.388672 1.093717-.533285.729144-.799928 1.701337-.799928 2.916578 0 .574478.066661 1.104764.211092 1.59086.144432.486097.344414.905908.633276 1.259432.277753.353525.611056.629716.99991.828574.388853.209905.844367.309334 1.355432.309334.577725 0 1.05546-.121524 1.455423-.353525.399964-.232.722157-.541335.97769-.905907.255531-.37562.444403-.79543.555504-1.270479.099991-.475049.155542-.961145.155542-1.458289zm4.432931-9.99812h2.510883v2.364197h-2.510883V11.07005zm0 4.31963h2.510883v11.334883h-2.510883V15.389679zm4.755124-4.31963h2.510883v15.654513h-2.510883V11.07005zm10.210184 15.963847c-.911029 0-1.722066-.154667-2.433113-.452953-.711046-.298287-1.310992-.718097-1.810946-1.237337-.488845-.530287-.866588-1.160002-1.12212-1.889147-.255533-.729144-.388854-1.535622-.388854-2.408386 0-.861716.133321-1.657147.388853-2.386291.255533-.729145.633276-1.35886 1.12212-1.889148.488845-.530287 1.0999-.93905 1.810947-1.237336.711047-.298286 1.522084-.452953 2.433113-.452953.911028 0 1.722066.154667 2.433112.452953.711047.298287 1.310992.718097 1.810947 1.237336.488844.530287.866588 1.160003 1.12212 1.889148.255532.729144.388854 1.524575.388854 2.38629 0 .872765-.133322 1.679243-.388854 2.408387-.255532.729145-.633276 1.35886-1.12212 1.889147-.488845.530287-1.0999.93905-1.810947 1.237337-.711046.298286-1.522084.452953-2.433112.452953zm0-1.977528c.555505 0 1.04435-.121524 1.455423-.353525.411074-.232.744377-.541335 1.01102-.916954.266642-.37562.455513-.806478.588835-1.281527.12221-.475049.188872-.961145.188872-1.45829 0-.486096-.066661-.961144-.188872-1.44724-.122211-.486097-.322193-.905907-.588836-1.281527-.266642-.37562-.599945-.673907-1.011019-.905907-.411074-.232-.899918-.353525-1.455423-.353525-.555505 0-1.04435.121524-1.455424.353525-.411073.232-.744376.541334-1.011019.905907-.266642.37562-.455514.79543-.588835 1.281526-.122211.486097-.188872.961145-.188872 1.447242 0 .497144.06666.98324.188872 1.458289.12221.475049.322193.905907.588835 1.281527.266643.37562.599946.684954 1.01102.916954.411073.243048.899918.353525 1.455423.353525zm6.4883-9.66669h1.899827v-3.402674h2.510883v3.402675h2.26646v1.867052h-2.26646v6.054109c0 .265143.01111.486096.03333.684954.02222.18781.07777.353524.155541.486096.077771.132572.199982.232.366634.298287.166651.066285.377743.099428.666606.099428.177762 0 .355523 0 .533285-.011047.177762-.011048.355523-.033143.533285-.077334v1.933338c-.277753.033143-.555505.055238-.811038.088381-.266642.033143-.533285.04419-.811037.04419-.666606 0-1.199891-.066285-1.599855-.18781-.399963-.121523-.722156-.309333-.944358-.552381-.233313-.243049-.377744-.541335-.466625-.905907-.07777-.364573-.133321-.784383-.144431-1.248384v-6.683825h-1.899827v-1.889147h-.02222z"
                  fill="#191919"
                ></path>
                <path
                  class="tp-logo__star"
                  fill="#00B67A"
                  d="M30.141707 11.07005H18.63164L15.076408.177071l-3.566342 10.892977L0 11.059002l9.321376 6.739063-3.566343 10.88193 9.321375-6.728016 9.310266 6.728016-3.555233-10.88193 9.310266-6.728016z"
                ></path>
                <path
                  class="tp-logo__star-notch"
                  fill="#005128"
                  d="M21.631369 20.26169l-.799928-2.463625-5.755033 4.153914z"
                ></path>
              </svg>

              <!-- <img src="assets/img/trustpilot-one-and-text.svg" alt="" /> -->
            </div>
          </div>
        </div>
        <div class="cont-bloc-check">
          <div class="block-check">
            <div class="check">
              <svg
                width="16"
                height="11"
                viewBox="0 0 16 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1752 0.51076C15.0783 0.413126 14.9631 0.335632 14.8362 0.282748C14.7093 0.229864 14.5731 0.202637 14.4356 0.202637C14.2981 0.202637 14.1619 0.229864 14.035 0.282748C13.9081 0.335632 13.7929 0.413126 13.696 0.51076L5.9356 8.28159L2.67518 5.01076C2.57464 4.91364 2.45595 4.83727 2.32589 4.78601C2.19583 4.73476 2.05695 4.70962 1.91718 4.71204C1.77741 4.71446 1.63948 4.74438 1.51128 4.80011C1.38307 4.85583 1.26709 4.93626 1.16997 5.0368C1.07285 5.13734 0.996479 5.25603 0.945225 5.38609C0.893971 5.51615 0.868835 5.65503 0.871253 5.7948C0.873671 5.93457 0.903596 6.0725 0.959318 6.2007C1.01504 6.32891 1.09547 6.44489 1.19601 6.54201L5.19601 10.542C5.29285 10.6396 5.40806 10.7171 5.535 10.77C5.66193 10.8229 5.79808 10.8501 5.9356 10.8501C6.07311 10.8501 6.20926 10.8229 6.3362 10.77C6.46313 10.7171 6.57834 10.6396 6.67518 10.542L15.1752 2.04201C15.2809 1.94447 15.3653 1.82608 15.423 1.69431C15.4807 1.56254 15.5105 1.42024 15.5105 1.27639C15.5105 1.13253 15.4807 0.990232 15.423 0.858462C15.3653 0.726691 15.2809 0.608304 15.1752 0.51076Z"
                  fill="url(#paint0_linear_7320_1592)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_7320_1592"
                    x1="13.3083"
                    y1="-8.32215"
                    x2="2.29383"
                    y2="3.6215"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF6713" />
                    <stop offset="1" stop-color="#FF9B00" />
                  </linearGradient>
                </defs>
              </svg>
              <!-- <img src="assets/img/check2.svg" alt="check"> -->
            </div>
            <div class="check-text">Gratuit</div>
          </div>
          <div class="block-check">
            <div class="check">
              <svg
                width="16"
                height="11"
                viewBox="0 0 16 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.1752 0.51076C15.0783 0.413126 14.9631 0.335632 14.8362 0.282748C14.7093 0.229864 14.5731 0.202637 14.4356 0.202637C14.2981 0.202637 14.1619 0.229864 14.035 0.282748C13.9081 0.335632 13.7929 0.413126 13.696 0.51076L5.9356 8.28159L2.67518 5.01076C2.57464 4.91364 2.45595 4.83727 2.32589 4.78601C2.19583 4.73476 2.05695 4.70962 1.91718 4.71204C1.77741 4.71446 1.63948 4.74438 1.51128 4.80011C1.38307 4.85583 1.26709 4.93626 1.16997 5.0368C1.07285 5.13734 0.996479 5.25603 0.945225 5.38609C0.893971 5.51615 0.868835 5.65503 0.871253 5.7948C0.873671 5.93457 0.903596 6.0725 0.959318 6.2007C1.01504 6.32891 1.09547 6.44489 1.19601 6.54201L5.19601 10.542C5.29285 10.6396 5.40806 10.7171 5.535 10.77C5.66193 10.8229 5.79808 10.8501 5.9356 10.8501C6.07311 10.8501 6.20926 10.8229 6.3362 10.77C6.46313 10.7171 6.57834 10.6396 6.67518 10.542L15.1752 2.04201C15.2809 1.94447 15.3653 1.82608 15.423 1.69431C15.4807 1.56254 15.5105 1.42024 15.5105 1.27639C15.5105 1.13253 15.4807 0.990232 15.423 0.858462C15.3653 0.726691 15.2809 0.608304 15.1752 0.51076Z"
                  fill="url(#paint0_linear_7320_1592)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_7320_1592"
                    x1="13.3083"
                    y1="-8.32215"
                    x2="2.29383"
                    y2="3.6215"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="#FF6713" />
                    <stop offset="1" stop-color="#FF9B00" />
                  </linearGradient>
                </defs>
              </svg>
              <!-- <img src="assets/img/check2.svg" alt="check"> -->
            </div>
            <div class="check-text">Sans engagement</div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sexe -->
  <div *ngIf="curentQuestion == 1" class="sub-container">
    <div class="">
      <div class="progress XsPGB" style="display: none">
        <div class="progress-bar-orange p-bar-16"></div>
      </div>

      <div class="divTitre">
        <h1 id="titre">Votre profil</h1>
        <div class="minute">
          <img src="assets/img/horloge.svg" alt="" />
          <p class="minute-text">2 minutes</p>
        </div>
      </div>
      <div class="progress">
        <div class="progress-bar-orange p-bar-16"></div>
      </div>
      <div class="card">
        <div class="cardTitre">
          <div id="back" (click)="goBack(curentQuestion)">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              (click)="toggleBtnQ0()"
            >
              <path
                d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
                fill="#4D4D4D"
              />
            </svg>
            <!-- <img (click)="toggleBtnQ0()" src="assets/img/back.svg" alt=""/> -->
          </div>
          <div id="question">
            <h2>Vous êtes ?</h2>
          </div>
        </div>
        <div class="blocChoix">
          <div class="choix">
            <label>
              <input
                (click)="getCheckedValue('Sexe', '1')"
                type="radio"
                name="Sexe"
                class="card-input-element"
                [checked]="personne.sexe == '1'"
              />
              <div class="panel panel-default card-input HF">
                <!-- <div class="check-icon HF"><img style="margin-left: -5px;" src="assets/img/check.svg" alt="" /></div> -->
                <div class="panel-heading">
                  <img
                    src="assets/img/femme.svg"
                    class="img115"
                    alt=""
                    height="90px"
                  />
                </div>
                <div class="panel-body">Une femme</div>
              </div>
            </label>
          </div>
          <div class="choix">
            <label>
              <input
                (click)="getCheckedValue('Sexe', '2')"
                type="radio"
                name="Sexe"
                class="card-input-element"
                [checked]="personne.sexe == '2'"
              />
              <div class="panel panel-default card-input HF">
                <!-- <div class="check-icon HF"><img style="margin-left: -5px;" src="assets/img/check.svg" alt="" /></div> -->
                <div class="panel-heading">
                  <img
                    src="assets/img/homme.svg"
                    class="img115"
                    alt=""
                    height="90px"
                  />
                </div>
                <div class="panel-body">Un homme</div>
              </div>
            </label>
          </div>
        </div>
        <div *ngIf="displayBtnQ1" class="blocBoutton button_next">
          <!-- <button id="nextButton" (click)="goNextStep()"> -->
          <!-- <button id="nextButton" (click)="goNextStep()"></button> -->
          <ng-container *ngTemplateOutlet="contentNext02"></ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- NombreEnfants  currentQuestion == 2-->
  <div *ngIf="curentQuestion == 200" class="margin015 sub-container">
    <div class="progress">
      <div class="progress-bar-orange"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>

          <!-- <img src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Combien d'enfants souhaitez-vous assurer ?</h2>
        </div>
      </div>

      <div class="blocChoix">
        <div class="choix">
          <label>
            <!-- <input type="radio" name="product" class="card-input-element"> -->
            <!-- <input (click)="setQuestionValue('CompositionFamiliale', '4')" type="radio" name="CompositionFamiliale" -->
            <input
              (click)="getCheckedValue('NombreEnfants', '1')"
              type="radio"
              name="NombreEnfants"
              class="card-input-element"
              [checked]="personne.enfant.nombreEnfants == '1'"
            />
            <div class="panel panel-default card-input">
              <div class="check-icon">
                <img src="assets/img/check.svg" alt="" />
              </div>
              <div class="panel-heading">
                <img src="assets/img/enfant_1.svg" height="75px" alt="" />
              </div>
              <div class="panel-body">1 enfant</div>
            </div>
          </label>
        </div>
        <div class="choix">
          <label>
            <input
              (click)="getCheckedValue('NombreEnfants', '2')"
              type="radio"
              name="NombreEnfants"
              class="card-input-element"
              [checked]="personne.enfant.nombreEnfants == '2'"
            />

            <div class="panel panel-default card-input">
              <div class="check-icon">
                <img src="assets/img/check.svg" alt="" />
              </div>
              <div class="panel-heading">
                <img src="assets/img/enfant_2.svg" height="75px" alt="" />
              </div>
              <div class="panel-body">2 enfants</div>
            </div>
          </label>
        </div>
        <div class="choix">
          <label>
            <input
              (click)="getCheckedValue('NombreEnfants', '3')"
              type="radio"
              name="NombreEnfants"
              class="card-input-element"
              [checked]="personne.enfant.nombreEnfants == '3'"
            />

            <div class="panel panel-default card-input">
              <div class="check-icon">
                <img src="assets/img/check.svg" alt="" />
              </div>
              <div class="panel-heading">
                <img src="assets/img/enfant_3.svg" height="75px" alt="" />
              </div>
              <div class="panel-body">3 enfants</div>
            </div>
          </label>
        </div>
        <div class="choix">
          <label>
            <input
              (click)="getCheckedValue('NombreEnfants', '4')"
              type="radio"
              name="NombreEnfants"
              class="card-input-element"
              [checked]="personne.enfant.nombreEnfants == '4'"
            />

            <div class="panel panel-default card-input">
              <div class="check-icon">
                <img src="assets/img/check.svg" alt="" />
              </div>
              <div class="panel-heading">
                <img src="assets/img/enfant_4.svg" height="75px" alt="" />
              </div>
              <div class="panel-body">4 enfants et plus</div>
            </div>
          </label>
        </div>
      </div>

      <div class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNext03"></ng-container>
      </div>
    </div>
  </div>

  <!-- DateNaissance -->
  <div *ngIf="showView('DateNaissance')" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-25"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Votre profil</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-25"></div>
    </div>

    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="toggleBtnQ1()"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img (click)="toggleBtnQ1()" src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Votre date de naissance ?</h2>
        </div>
      </div>
      <div class="blocInput">
        <div id="bImage">
          <img *ngIf="personne.sexe == '1'" src="assets/img/femme.svg" alt="" />
          <img *ngIf="personne.sexe == '2'" src="assets/img/homme.svg" alt="" />
        </div>
        <div id="bInput" class="bInputDateNaissance">
          <!-- <input type="date" name="" id=""> -->

          <!-- <mat-form-field id="bInput">
              <wz-date-input #inputDateNaissanceAssure formControlName="dateNaissance" placeholder="Date de naissance"
                [(ngModel)]="personne.dateNaissanceAssure"></wz-date-input>
              <mat-error *ngIf="dateNaissanceCtrl.hasError('majorPerson')" wzI18n="FORMS_BIRTHDAY_MAJORPERSON">
              </mat-error>
              <mat-error *ngIf="dateNaissanceCtrl.hasError('required')" wzI18n="FORMS_BIRTHDAY_REQUIRED">
              </mat-error>
              <mat-error *ngIf="dateNaissanceCtrl.hasError('max')" wzI18n="FORMS_BIRTHDAY_MIN" [wzI18nParams]="minAge">
              </mat-error>
              <mat-error *ngIf="dateNaissanceCtrl.hasError('min')" wzI18n="FORMS_BIRTHDAY_MAX" [wzI18nParams]="maxAge">
              </mat-error>
              <mat-hint><span wzI18n="FORMS_DATE_HINT"></span></mat-hint>
            </mat-form-field> -->
          <!--
          <input type="date" #inputDateNaissanceAssure formControlName="dateNaissance" placeholder="Date de naissance"
            min="{{ DateNaissanceMin | date: 'yyyy-MM-dd' }}" max="{{ DateNaissanceMax | date: 'yyyy-MM-dd' }}"
            [(ngModel)]="personne.dateNaissanceAssure" /> -->

          <input
            type="text"
            mask="d0/M0/0000"
            placeholder="JJ/MM/AAAA"
            (keyup)="setDateF('DateNaissance', personne.dateNaissanceAssure)"
            formControlName="dateNaissance"
            inputmode="numeric"
            #inputDateNaissanceAssure
            [(ngModel)]="personne.dateNaissanceAssure"
          />

          <p
            *ngIf="
              dateNaissanceCtrl.hasError('majorPerson') && dateNatHasChanged
            "
            wzI18n="FORMS_BIRTHDAY_MAJORPERSON"
            class="alertcss child18 alertcss margintop1"
          ></p>
          <p
            *ngIf="
              dateNaissanceCtrl.hasError('required') &&
              dateNaissanceCtrl.value.length > 0 &&
              dateNatHasChanged
            "
            wzI18n="FORMS_BIRTHDAY_REQUIRED"
            class="alertcss child18 alertcss margintop1"
          ></p>
          <p
            *ngIf="
              CtrlDateNaissance > DateNaissanceMax &&
              personne.dateNaissanceAssure.length > 0 &&
              dateNatHasChanged
            "
            class="alertcss child18 margintop1"
            
          >
            Vous devez avoir plus de 18 ans pour souscrire un contrat santé.
          </p>
          <p
            *ngIf="
              CtrlDateNaissance < DateNaissanceMin &&
              personne.dateNaissanceAssure.length > 0 &&
              dateNatHasChanged
            "
            class="alertcss child18 margintop1"
          >
            Nous sommes désolés mais nous n'avons pas d'offre pour les plus de
            90 ans.
          </p>
          <!-- <mat-form-field appearance="none">
              <mat-label>Date de naissance</mat-label>
              <input matInput [matDatepicker]="picker">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field> -->
        </div>
      </div>

      <div class="blocBoutton button_next">
        <ng-container
          *ngTemplateOutlet="
            contentNextDN;
            context: { inputDateNaissanceAssure: inputDateNaissanceAssure }
          "
        ></ng-container>
      </div>
    </div>
  </div>

  <!-- RegimeSocial -->
  <div *ngIf="showView('RegimeSocial')" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-33"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Votre profil</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-33" style="width: 33.32%"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Votre régime social ?</h2>
        </div>
      </div>
      <div class="blocChoix rchoix">
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('RegimeSocial', '0')"
              type="radio"
              name="RegimeSocial"
              class="card-input-element"
              [checked]="personne.regimeSocial == '0'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">Régime général</div>
            </div>
          </label>
        </div>
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('RegimeSocial', '1')"
              type="radio"
              name="RegimeSocial"
              class="card-input-element"
              [checked]="personne.regimeSocial == '1'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">Travailleur non salarié</div>
            </div>
          </label>
        </div>
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('RegimeSocial', '2')"
              type="radio"
              name="RegimeSocial"
              class="card-input-element"
              [checked]="personne.regimeSocial == '2'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">
                Sécurité sociale agricole
              </div>
            </div>
          </label>
        </div>
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('RegimeSocial', '3')"
              type="radio"
              name="RegimeSocial"
              class="card-input-element"
              [checked]="personne.regimeSocial == '3'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">Alsace-moselle</div>
            </div>
          </label>
        </div>
      </div>
      <div *ngIf="displayBtnQRS" class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNextRS"></ng-container>
      </div>
    </div>
  </div>

  <!-- ConjointDateNaissance, currenquestion = 4 -->
  <div
    *ngIf="showView('ConjointDateNaissance')"
    class="sub-container profil-conjoint"
  >
    <!-- <div *ngIf="curentQuestion == 5" class="container"> -->
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-41"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Profil du conjoint</h1>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-41"></div>
    </div>

    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="toggleBtnQRS()"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img (click)="toggleBtnQRS()" src="assets/img/back.svg" alt=""> -->
        </div>
        <div id="question">
          <h2>Date de naissance de votre conjoint ?</h2>
        </div>
      </div>
      <!-- (change)="onChange($event, element)" -->
      <div class="blocInput">
        <div id="bInput">
          <!-- <input #inputDateNaissanceConjoint name="ConjointDateNaissance" type="date" placeholder="jj/mm/aaaa" /> -->
          <!-- <mat-form-field id="bInput">
                        <wz-date-input #inputDateNaissanceConjoint formControlName="dateNaissance"
                            placeholder="Date de naissance conjoint" [(ngModel)]="personne.dateNaissanceConjoint">
                        </wz-date-input>
                        <mat-error *ngIf="dateNaissanceCtrl.hasError('majorPerson')"
                            wzI18n="FORMS_BIRTHDAY_MAJORPERSON">
                        </mat-error>
                        <mat-error *ngIf="dateNaissanceCtrl.hasError('required')" wzI18n="FORMS_BIRTHDAY_REQUIRED">
                        </mat-error>
                        <mat-error *ngIf="dateNaissanceCtrl.hasError('max')" wzI18n="FORMS_BIRTHDAY_MIN"
                            [wzI18nParams]="minAge">
                        </mat-error>
                        <mat-error *ngIf="dateNaissanceCtrl.hasError('min')" wzI18n="FORMS_BIRTHDAY_MAX"
                            [wzI18nParams]="maxAge">
                        </mat-error>
                        <mat-hint><span wzI18n="FORMS_DATE_HINT"></span></mat-hint>
                    </mat-form-field> -->

          <input
            type="text"
            mask="d0/M0/0000"
            [(ngModel)]="personne.dateNaissanceConjoint"
            placeholder="JJ/MM/AAAA"
            (keyup)="
              setDateF('DateNaissanceConjoint', personne.dateNaissanceConjoint)
            "
            formControlName="dateNaissance"
            inputmode="numeric"
            #inputDateNaissanceConjoint
          />

          <p
            *ngIf="
              dateNaissanceCtrl.hasError('majorPerson') &&
              dateNatConjointHasChanged
            "
            wzI18n="FORMS_BIRTHDAY_MAJORPERSON"
            class="alertcss child18 alertcss margintop1"
          ></p>
          <p
            *ngIf="
              dateNaissanceCtrl.hasError('required') &&
              dateNaissanceCtrl.value.length &&
              dateNatConjointHasChanged
            "
            wzI18n="FORMS_BIRTHDAY_REQUIRED"
            class="alertcss child18 alertcss margintop1"
          ></p>
          <p
            *ngIf="
              CtrlDateNaissance > DateNaissanceMax &&
              personne.dateNaissanceConjoint.length > 0 &&
              dateNatConjointHasChanged
            "
            class="alertcss child18 alertcss margintop1"
          >
            Votre conjoint doit avoir plus de 18 ans pour souscrire un contrat
            santé.
          </p>
          <p
            *ngIf="
              CtrlDateNaissance < DateNaissanceMin &&
              personne.dateNaissanceConjoint.length > 0 &&
              dateNatConjointHasChanged
            "
            class="alertcss child18 alertcss margintop1"
          >
            Nous sommes désolés mais nous n'avons pas d'offre pour les plus de
            90 ans.
          </p>
        </div>
      </div>
      <div class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNextCDN"></ng-container>
      </div>
    </div>
  </div>

  <!-- ConjointRegimeSocial currenquestion = 5-->
  <div *ngIf="showView('ConjointRegimeSocial')" class="sub-container">
    <!-- <div *ngIf="curentQuestion == 6" class="container"> -->
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-50"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Profil du conjoint</h1>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-50"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div
          id="back"
          (click)="
            goBack(curentQuestion, { keystring: 'ConjointDateNaissance' })
          "
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Régime social de votre conjoint ?</h2>
        </div>
      </div>

      <div class="blocChoix rchoix">
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('ConjointRegimeSocial', '0')"
              type="radio"
              name="ConjointRegimeSocial"
              class="card-input-element"
              [checked]="personne.conjointRegimeSociale == '0'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">Régime général</div>
            </div>
          </label>
        </div>
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('ConjointRegimeSocial', '1')"
              type="radio"
              name="ConjointRegimeSocial"
              class="card-input-element"
              [checked]="personne.conjointRegimeSociale == '1'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">Travailleur non salarié</div>
            </div>
          </label>
        </div>
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('ConjointRegimeSocial', '2')"
              type="radio"
              name="ConjointRegimeSocial"
              class="card-input-element"
              [checked]="personne.conjointRegimeSociale == '2'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">
                Sécurité sociale agricole
              </div>
            </div>
          </label>
        </div>
        <div class="choix rchoix">
          <label>
            <input
              (click)="getCheckedValue('ConjointRegimeSocial', '3')"
              type="radio"
              name="ConjointRegimeSocial"
              class="card-input-element"
              [checked]="personne.conjointRegimeSociale == '3'"
            />

            <div class="panel panel-default card-input">
              <!-- <div class="check-icon"><img class="margin-5" src="assets/img/check.svg" alt="" /></div> -->
              <div class="panel-heading"></div>
              <div class="panel-body margin0 mt-0">Alsace-moselle</div>
            </div>
          </label>
        </div>
      </div>

      <div *ngIf="displayBtnQRSC" class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNextCRS"></ng-container>
      </div>
    </div>
  </div>

  <!--EnfantsDateNaissance, currentQuestion =6 -->
  <div *ngIf="showView('EnfantsDateNaissance')" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-58"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Votre profil</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-58"></div>
    </div>

    <form
      [formGroup]="dateNaissanceEnfantForm"
      class="card blocEnfantCard"
      (ngSubmit)="getInputDateNaissanceEnfants('EnfantsDateNaissance')"
      #formDNEnf
    >
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion, null, true)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="toggleBtnQDepuisEnfant()"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img (click)="toggleBtnQDepuisEnfant()" src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Dates de naissance de vos enfants ?</h2>
        </div>
      </div>

      <div class="blocInput">
        <div id="bImage">
          <img src="assets/img/enfant_3.svg" height="160px" alt="" />
        </div>

        <div
          id="bInput"
          #formDNEnfant
          class="bInputContact"
          formArrayName="dateNaissanceEnfant"
        >
          <!-- <div class="groupInput">
                        <label for="enfant1">1er enfant</label>
                        <input class="form-control" #inputEnfant1="ngModel" [required]="true" name="enfant1" type="date"
                            maxlength="10"
                            [(ngModel)]="personne.enfant.dateNaissanceEnfant[0]" [ngModelOptions]="{ standalone: true }"
                            pattern="(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))" />
                        <div *ngIf="(inputEnfant1.invalid && inputEnfant1.dirty) || !checkChild(0)">
                            <p class="alertcss child18">Veuillez renseigner une date de naissance
                                valide.</p>
                        </div>
                        <div *ngIf="inputEnfant1.valid && checkChild18(0)">
                            <p class="alert alert-info text-center child18 ">
                                Votre enfant a plus de 18 ans
                            </p>
                        </div>
                    </div> -->

          <div
            class="groupDateNaissance"
            *ngFor="let item of dateNaissanceEnfant().controls; let i = index"
            [formGroupName]="i"
          >
            <div class="groupInput">
              <label *ngIf="i == 0" for="enfant1">{{ i + 1 }}er enfant</label>
              <label *ngIf="i > 0" for="enfant1">{{ i + 1 }}ème enfant</label>

              <!-- <input formControlName="date_enfant" type="date" class="form-control"
                [(ngModel)]="personne.enfant.dateNaissanceEnfant[i]" min="{{ dateMaxEnfant | date: 'yyyy-MM-dd' }}"
                max="{{ dateDuJour | date: 'yyyy-MM-dd' }}" />
               -->

              <!-- <div *ngIf="(item.invalid && item.dirty) || item.errors || !checkChild(i)">
                <p class="alertcss">Veuillez renseigner une date de naissance valide.</p>
              </div>
              <div *ngIf="item.valid && checkChild26(i)">
                <p class="alertcss">Votre enfant doit avoir moins de 26 ans.</p>
              </div>

              <div *ngIf="item.valid && checkChild18(i)">
                <p class="alert alert-info text-center ">
                  Votre enfant a entre 18 et 26 ans ? Pour figurer sur votre contrat, il doit être scolarisé ou en
                  alternance ou en apprentissage ou inscrit à pole emploi en tant que primo demandeur d'emploi. Et vous
                  devrez nous adresser un justificatif.
                </p>
              </div> -->

              <input
                type="text"
                class="form-control"
                placeholder="JJ/MM/AAAA"
                #inputDateEnfant
                (input)="
                  setDateNatEnfant(personne.enfant.dateNaissanceEnfant[i], i)
                "
                inputmode="numeric"
                [(ngModel)]="personne.enfant.dateNaissanceEnfant[i]"
                formControlName="date_enfant"
                mask="d0/M0/0000"
              />

              <div
                *ngIf="
                  (item.invalid || !checkChild(i)) &&
                  (item.touched || item.dirty)
                "
              >
                <p class="alertcss">
                  Veuillez renseigner une date de naissance valide.
                </p>
              </div>

              <div *ngIf="checkChild26(i)">
                <p class="alertcss">
                  Votre enfant doit avoir moins de 26 ans.
                </p>
              </div>

              <div *ngIf="checkChild18(i)">
                <p class="alertcss">
                  Votre enfant a entre 18 et 26 ans ? Pour figurer sur votre
                  contrat, il doit être scolarisé ou en alternance ou en
                  apprentissage ou inscrit à pole emploi en tant que primo
                  demandeur d'emploi. Et vous devrez nous adresser un
                  justificatif.
                </p>
              </div>
            </div>
            <div class="deleteDateNaissance">
              <span type="button" (click)="remove_enfant(i)">
                <img src="assets/img/close-alt.svg" alt="" />
              </span>
            </div>
          </div>
          <div
            class="bAddEnfant"
            *ngIf="dateNaissanceEnfant().controls.length <= 5"
          >
            <img src="assets/img/plus.svg" alt="" />
            <button id="addButton" type="button" (click)="add_enfant()">
              Ajouter un enfant
            </button>
          </div>
        </div>
      </div>

      <div
        class="blocBoutton button_next"
        *ngIf="dateNaissanceEnfant().controls.length > 0"
      >
        <button
          [disabled]="checkChildAny26()"
          type="submit"
          id="nextButton"
          class="gray"
          [ngClass]="{
            gray: checkChildAny26(),
            orange: !checkChildAny26(),
          }"
        >
          Suivant
          <img src="assets/img/next.svg" alt="" />
        </button>
      </div>
      <!-- <div class="blocBoutton blocEnfant" *ngIf="dateNaissanceEnfant().controls.length > 0">
        <button [disabled]="dateNaissanceEnfantForm.invalid || checkChildAny26()" type="submit" id="nextButton"
          class="nextBtnChild" [ngClass]="{
            gray: dateNaissanceEnfantForm.invalid || checkChildAny26(),
            orange: dateNaissanceEnfantForm.valid && !checkChildAny26()
          }"
        >
          Suivant
          <img src="assets/img/next.svg" alt="" />
        </button>
      </div> -->
    </form>
  </div>

  <!-- DateDebutContrat, currentQuestion = 7 -->
  <div *ngIf="showView('DateDebutContrat')" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange" style="width: 66.66%"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Date de début du contrat</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange" style="width: 66.66%"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img (click)="toggleBtnQRS()" src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Quand souhaitez-vous débuter votre contrat ?</h2>
        </div>
      </div>
      <div class="blocInput">
        <div id="bInput" class="bInputDateContrat">
          <!-- <div class="groupInput">
            <label for="debutContrat">Date de début de contrat souhaitée</label>
            <input
              #inputDateDebutContrat
              name="DateDebutContrat"
              type="date"
              id="DateDebutContrat"
              placeholder="jj/mm/aaaa"
              [(ngModel)]="personne.dateDebutContrat"
            />
          </div> -->
          <!-- <mat-form-field>
            <wz-date-input #inputDateDebutContrat formControlName="dateEffet"
              placeholder="Date de début de contrat souhaitée" [(ngModel)]="personne.dateDebutContrat">
            </wz-date-input>
            <mat-error *ngIf="dateEffectCtrl.hasError('required')">La date d'effet est obligatoire. </mat-error>
            <mat-error *ngIf="dateEffectCtrl.hasError('min')">La date d'effet doit être égale ou postérieure à {{
              healthEffectDateMin | date }}
            </mat-error>
            <mat-error *ngIf="dateEffectCtrl.hasError('max')">La date d'effet ne peut pas être supérieur à an.
            </mat-error>
            <mat-hint>
              <span wzI18n="FORMS_DATE_HINT"></span>
            </mat-hint>
          </mat-form-field> -->

          <label for="debutContrat">Date de début de contrat souhaitée</label>
          <!-- <input type="date" #inputDateDebutContrat formControlName="dateEffet"
            placeholder="Date de début de contrat souhaitée" [(ngModel)]="personne.dateDebutContrat"
            min="{{ healthEffectDateMin | date: 'yyyy-MM-dd' }}" max="{{ dateEffetMax | date: 'yyyy-MM-dd' }}" /> -->

          <input
            type="text"
            mask="d0/M0/0000"
            [(ngModel)]="personne.dateDebutContrat"
            placeholder="JJ/MM/AAAA"
            (keyup)="setDateF('DateEffet', personne.dateDebutContrat)"
            formControlName="dateEffet"
            inputmode="numeric"
            #inputDateDebutContrat
          />

          <p
            *ngIf="
              dateEffectCtrl.hasError('required') &&
              personne.dateDebutContrat.length > 0 &&
              dateEffetHasChanged
            "
            class="alertcss mt-3"
          >
            La date d'effet est obligatoire.
          </p>
          <p
            *ngIf="
              CtrlDateEffet < healthEffectDateMin &&
              personne.dateDebutContrat.length > 0 &&
              dateEffetHasChanged
            "
            class="alertcss mt-3 child18"
          >
            La date d'effet doit être égale ou postérieure à
            {{ healthEffectDateMin | date }}
          </p>
          <p
            *ngIf="
              CtrlDateEffet > dateEffetMax &&
              personne.dateDebutContrat.length > 0 &&
              dateEffetHasChanged
            "
            class="alertcss mt-3 child18"
          >
            La date d'effet ne peut pas être supérieur à 1 an.
          </p>
          <p
            *ngIf="
              !dateEffetValideANI() &&
              !isDateEffetSuperior30Days &&
              personne.dateDebutContrat.length > 0 &&
              dateEffetHasChanged
            "
            class="alertcss mt-3 child18"
          >
            La date d'effet ne peut être inférieure à 30 jours.
          </p>

          <!-- {{ formatDateEffetMin }} // {{ dateEffectCtrl.value }} -->
          <!-- <p *ngIf="dateEffectCtrl.hasError('max')">
          <span>date d'effet ne peut pas être supérieur à an.</span>
        </p> -->
        </div>
      </div>
      <div class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNextDC"></ng-container>
      </div>
    </div>
  </div>

  <!-- Niveau remboursement, currentQuestion = 8 -->
  <div
    *ngIf="showView('NiveauRemboursement')"
    class="sub-container"
    id="niveau-remboursement"
  >
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-75"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Vos besoins</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-75"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Niveau de remboursement souhaité ?</h2>
        </div>
      </div>
      <div class="sousTitre">
        <p>
          Evaluez vos besoins sur ces cinq postes de santé afin de vous proposer
          les produits adaptés
        </p>
      </div>
      <div class="besoinChoix">
        <div class="medicaux">
          <div class="titleInfobulle">
            <div>
              <p class="choixTitre">
                <img src="assets/img/heartbeat-solid 1.svg" alt="" />
                Soins médicaux <br class="breaker" />
                <span>(médecin générale, pharmacie, radios, etc.)</span>
              </p>
            </div>

            <!-- TODO infobull -->
            <div class="infobulle">
              <img src="assets/img/info.png" alt="Information" />
              <infobulle-details-garanties
                class="infobulletext"
                id="infobulletext"
                [besoinsType]="besoins.Medecin"
              >
              </infobulle-details-garanties>
            </div>
          </div>

          <div class="blocChoix">
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'MedicauxMinimum',
                  'Minimum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="product"
                  class="card-input-element"
                  [checked]="
                    personne.niveauRemboursement.soinsMedicaux == 'Minimum'
                  "
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Minimum</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'MedicauxMoyen',
                  'Moyen'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="product"
                  class="card-input-element"
                  [checked]="
                    personne.niveauRemboursement.soinsMedicaux == 'Moyen'
                  "
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Moyen</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'MedicauxFort',
                  'Fort'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="product"
                  class="card-input-element"
                  [checked]="
                    personne.niveauRemboursement.soinsMedicaux == 'Fort'
                  "
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Fort</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'MedicauxMaximum',
                  'Maximum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="product"
                  class="card-input-element"
                  [checked]="
                    personne.niveauRemboursement.soinsMedicaux == 'Maximum'
                  "
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Maximum</div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="hospitalisation">
          <div class="titleInfobulle">
            <div>
              <p class="choixTitre">
                <img src="assets/img/ambulance.svg" alt="" />
                Hospitalisation <br class="breaker" />
                <span
                  >(frais de séjour, frais de transport, chirurgie, ect.)</span
                >
              </p>
            </div>

            <div class="infobulle">
              <img src="assets/img/info.png" alt="Information" />
              <infobulle-details-garanties
                class="infobulletext"
                [besoinsType]="besoins.Hospitalisation"
              >
              </infobulle-details-garanties>
            </div>
          </div>

          <div class="blocChoix">
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'HospiMinimum',
                  'Minimum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="hospitalisation"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.hospi == 'Minimum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Minimum</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'HospiMoyen',
                  'Moyen'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="hospitalisation"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.hospi == 'Moyen'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Moyen</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'HospiFort',
                  'Fort'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="hospitalisation"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.hospi == 'Fort'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Fort</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'HospiMaximum',
                  'Maximum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="hospitalisation"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.hospi == 'Maximum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Maximum</div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="dentaire">
          <div class="titleInfobulle">
            <div>
              <p class="choixTitre">
                <img src="assets/img/tooth-solid 1.svg" alt="" />
                Dentaire <br class="breaker" /><span
                  >(dentiste, prothèses, soins, etc.)</span
                >
              </p>
            </div>

            <div class="infobulle">
              <img src="assets/img/info.png" alt="Information" />
              <infobulle-details-garanties
                class="infobulletext"
                [besoinsType]="besoins.Dentaire"
              >
              </infobulle-details-garanties>
            </div>
          </div>
          <div class="blocChoix">
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'DentaireMinimum',
                  'Minimum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="dentaire"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.dentaire == 'Minimum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Minimum</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'DentaireMoyen',
                  'Moyen'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="dentaire"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.dentaire == 'Moyen'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Moyen</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'DentaireFort',
                  'Fort'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="dentaire"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.dentaire == 'Fort'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Fort</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'DentaireMaximum',
                  'Maximum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="dentaire"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.dentaire == 'Maximum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Maximum</div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="optique">
          <div class="titleInfobulle">
            <div>
              <p class="choixTitre">
                <img src="assets/img/glasses-alt-regular 1.svg" alt="" />
                Optique <br class="breaker" />
                <span>(lentilles, lunettes, chirurgie réfractive, etc.)</span>
              </p>
            </div>

            <div class="infobulle">
              <img src="assets/img/info.png" alt="Information" />
              <infobulle-details-garanties
                class="infobulletext"
                [besoinsType]="besoins.Optique"
              >
              </infobulle-details-garanties>
            </div>
          </div>

          <div class="blocChoix">
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'OptiqueMinimum',
                  'Minimum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="optique"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.optique == 'Minimum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Minimum</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'OptiqueMoyen',
                  'Moyen'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="optique"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.optique == 'Moyen'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Moyen</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'OptiqueFort',
                  'Fort'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="optique"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.optique == 'Fort'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Fort</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'OptiqueMaximum',
                  'Maximum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="optique"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.optique == 'Maximum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Maximum</div>
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="audit">
          <div class="titleInfobulle">
            <div>
              <p class="choixTitre">
                <img src="assets/img/ear-solid 1.svg" alt="" />
                Aides auditives <br class="breaker" />
                <span>(appareillages auditifs etc...)</span>
              </p>
            </div>

            <div class="infobulle">
              <img src="assets/img/info.png" alt="Information" />
              <infobulle-details-garanties
                class="infobulletext"
                id="infobulletext"
                [besoinsType]="besoins.Auditif"
              >
              </infobulle-details-garanties>
            </div>
          </div>
          <div class="blocChoix">
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'AuditMinimum',
                  'Minimum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="audit"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.auditive == 'Minimum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Minimum</div>
                </div>
              </label>
            </div>

            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'AuditMoyen',
                  'Moyen'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="audit"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.auditive == 'Moyen'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Moyen</div>
                </div>
              </label>
            </div>

            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'AuditFort',
                  'Fort'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="audit"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.auditive == 'Fort'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Fort</div>
                </div>
              </label>
            </div>
            <div
              class="choix"
              (click)="
                getCheckedNiveauRemboursement(
                  'NiveauRemboursement',
                  'AuditMaximum',
                  'Maximum'
                )
              "
            >
              <label>
                <input
                  type="radio"
                  name="audit"
                  class="card-input-element"
                  [checked]="personne.niveauRemboursement.auditive == 'Maximum'"
                />

                <div class="panel panel-default card-input">
                  <div class="panel-body">Maximum</div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="blocBoutton button_next nvBtnFullScreen">
        <!-- <div class="blocBoutton" *ngIf="displayBtnR"> -->
        <ng-container *ngTemplateOutlet="contentNextNivRemb"></ng-container>
      </div>
    </div>

    <!--
    <div class="blocBoutton button_next nvBtn" style="display: none;">
      <-- <div class="blocBoutton" *ngIf="displayBtnR"> ->
      <button
        id="nextButton"
        (click)="goNextStep2(curentQuestion); setTagNvRemb()"
        [ngClass]="{
          gray:
            !(personne.niveauRemboursement.hospi.length != 0) ||
            !(personne.niveauRemboursement.soinsMedicaux.length != 0) ||
            !(personne.niveauRemboursement.dentaire.length != 0) ||
            !(personne.niveauRemboursement.optique.length != 0) ||
            !(personne.niveauRemboursement.auditive.length != 0),
          orange:
            personne.niveauRemboursement.hospi.length != 0 &&
            personne.niveauRemboursement.soinsMedicaux.length != 0 &&
            personne.niveauRemboursement.dentaire.length != 0 &&
            personne.niveauRemboursement.optique.length != 0 &&
            personne.niveauRemboursement.auditive.length != 0
        }"
        [disabled]="
          !(personne.niveauRemboursement.hospi.length != 0) ||
          !(personne.niveauRemboursement.soinsMedicaux.length != 0) ||
          !(personne.niveauRemboursement.dentaire.length != 0) ||
          !(personne.niveauRemboursement.optique.length != 0) ||
          !(personne.niveauRemboursement.auditive.length != 0)
        "
      >
        Suivant
        <img src="assets/img/next.svg" alt="" />
      </button>
    </div>

    -->
  </div>

  <!-- Nom Prenom, currentQuestion = 9 -->
  <div *ngIf="showView('NomPrenom')" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange p-bar-83"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Vos coordonnées</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange p-bar-83"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            (click)="toggleBtnR()"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img src="assets/img/back.svg" alt="" (click)="toggleBtnR()"/> -->
        </div>
        <div id="question">
          <h2>Dites-nous en plus sur vous ...</h2>
        </div>
      </div>
      <div class="blocInput">
        <div id="bImage">
          <img *ngIf="personne.sexe == '1'" src="assets/img/femme.svg" alt="" />
          <img *ngIf="personne.sexe == '2'" src="assets/img/homme.svg" alt="" />
        </div>
        <div id="bInput" class="bInputDaWithLabel">
          <div class="groupInput">
            <label for="departement">Votre prénom</label>
            <input
              type="text"
              #inputPrenom
              placeholder="Prénom"
              (change)="changeFirstName($event)"
              formControlName="prenom"
              [(ngModel)]="personne.prenom"
            />
            <div *ngIf="prenomCtrl.hasError('pattern')">
              <p class="alertcss">
                Le prénom est invalide
              </p>
            </div>

            <!-- <label for="prenom">Votre prénom</label>
                        <input
                            #inputPrenom
                            type="text"
                            name="prenom"
                            id="prenom"
                            placeholder="Ex : Martin"
                            (blur)="personne.prenom = inputPrenom.value"
                            [value]="personne.prenom" /> -->
            <!-- <mat-form-field>
              <wz-text-input #inputPrenom placeholder="Prénom" formControlName="prenom" [(ngModel)]="personne.prenom">
              </wz-text-input>
              <mat-error *ngIf="prenomCtrl.hasError('required')" wzI18n="FORMS_FIRSTNAME_REQUIRED"> </mat-error>
              <mat-error *ngIf="prenomCtrl.hasError('pattern')" wzI18n="FORMS_FIRSTNAME_PATTERN"> </mat-error>
            </mat-form-field> -->
          </div>
          <div class="groupInput">
            <label for="departement">Votre nom</label>
            <input
              type="text"
              #inputNom
              placeholder="Nom"
              (change)="changeName($event)"
              formControlName="nom"
              [(ngModel)]="personne.nom"
            />
            <div *ngIf="nomCtrl.hasError('pattern')">
              <p class="alertcss">Le nom est invalide</p>
            </div>

            <!-- <label for="nom">Votre nom</label>
                        <input
                            #inputNom
                            type="text"
                            name="nom"
                            id="nom"
                            placeholder="Ex : Dupont"
                            (blur)="personne.nom = inputNom.value"
                            [value]="personne.nom" /> -->
            <!-- <mat-form-field>
              <wz-text-input #inputNom placeholder="Nom" formControlName="nom" [(ngModel)]="personne.nom">
              </wz-text-input>
              <mat-error *ngIf="nomCtrl.hasError('required')" wzI18n="FORMS_LASTNAME_REQUIRED"> </mat-error>
              <mat-error *ngIf="nomCtrl.hasError('pattern')" wzI18n="FORMS_LASTNAME_PATTERN"></mat-error>
            </mat-form-field> -->
          </div>
        </div>
      </div>
      <div class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNextNomPrenom"></ng-container>
      </div>
    </div>
  </div>

  <!-- Adresse, currentQuestion = 10 -->
  <div *ngIf="showView('Departement')" class="sub-container">
    <div class="progress XsPGB" style="display: none">
      <div class="progress-bar-orange" style="width: 91.66%"></div>
    </div>

    <div class="divTitre">
      <h1 id="titre">Vos coordonnées</h1>
      <div class="minute">
        <img src="assets/img/horloge.svg" alt="" />
        <p class="minute-text">2 minutes</p>
      </div>
    </div>
    <div class="progress">
      <div class="progress-bar-orange" style="width: 91.66%"></div>
    </div>
    <div class="card">
      <div class="cardTitre">
        <div id="back" (click)="goBack(curentQuestion)">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
              fill="#4D4D4D"
            />
          </svg>
          <!-- <img src="assets/img/back.svg" alt=""/> -->
        </div>
        <div id="question">
          <h2>Où habitez-vous ?</h2>
        </div>
      </div>
      <div class="blocInput">
        <div id="bInput" class="bInputDaWithLabel">
          <div class="groupInput">
            <!-- <label for="departement">Votre département</label>
              <select id="departement" [value]="" (blur)="setQuestionValue('Departement', $event.target.value)">
                <option selected="">Sélectionnez votre département</option>
                <option value="01">Ain - Bourg-en-bresse</option>
                <option value="02">Aisne - Laon</option>
                <option value="50">Manche - Saint-lô</option>
                <option value="51">Marne - Châlons-en-champagne</option>
              </select> -->
            <!-- <formly-form [model]="healthAssureFormModel" [fields]="fieldsAdresse" [form]="formGroup">
            </formly-form> -->

            <!-- <mat-form-field>
              <wz-text-input formControlName="codePostal" placeholder="Code Postale" [(ngModel)]="personne.codePostal">
              </wz-text-input>
            </mat-form-field> -->

            <!-- <mat-form-field> -->
            <label for="departement">Code postal</label>

            <input
              [(ngModel)]="personne.codePostal"
              [mask]="'00000'"
              inputmode="numeric"
              matInput
              placeholder="Votre code postal"
              (change)="changePostalCode($event)"
              formControlName="codePostal"
              type="number"
            />

            <p
              *ngIf="codePostalCtrl.hasError('required')"
              wzI18n="FORMS_FIRSTNAME_REQUIRED"
              class="alertcss child18 alertcss"
            >
              Le code postal est obligatoire.
            </p>
            <p
              *ngIf="
                codePostalCtrl.value.length == 5 &&
                codePostalCtrl.hasError('pattern')
              "
              class="alertcss child18 alertcss"
            >
              Désolé, nous n’avons pas d’offres éligibles dans votre zone de
              résidence.
            </p>

            <!-- </mat-form-field> -->
          </div>
        </div>
      </div>
      <div class="blocBoutton button_next">
        <ng-container *ngTemplateOutlet="contentNextDep"></ng-container>
      </div>
    </div>
  </div>

  <!-- Contact , currentQuestion = 11-->
  <div *ngIf="showView('Contact')" class="sub-container">
    <div class="contact-form" *ngIf="showDiv">
      <div class="progress XsPGB" style="display: none">
        <div class="progress-bar-orange p-bar-100"></div>
      </div>

      <div class="divTitre">
        <h1 id="titre">Vos coordonnées</h1>
        <div class="minute">
          <img src="assets/img/horloge.svg" alt="" />
          <p class="minute-text">2 minutes</p>
        </div>
      </div>
      <div class="progress">
        <div class="progress-bar-orange p-bar-100"></div>
      </div>
      <div class="card">
        <div class="cardTitre">
          <div id="back" (click)="goBack(curentQuestion)">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.25 6.75023H4.76249L8.88749 2.63773C9.12287 2.40235 9.25511 2.08311 9.25511 1.75023C9.25511 1.41735 9.12287 1.09811 8.88749 0.862732C8.65211 0.627352 8.33287 0.495117 7.99999 0.495117C7.66712 0.495117 7.34787 0.627352 7.11249 0.862732L0.862493 7.11273C0.748692 7.23161 0.659485 7.37179 0.599992 7.52523C0.47497 7.82956 0.47497 8.1709 0.599992 8.47523C0.659485 8.62867 0.748692 8.76885 0.862493 8.88773L7.11249 15.1377C7.2287 15.2549 7.36695 15.3479 7.51927 15.4113C7.6716 15.4748 7.83498 15.5075 7.99999 15.5075C8.16501 15.5075 8.32839 15.4748 8.48071 15.4113C8.63304 15.3479 8.77129 15.2549 8.88749 15.1377C9.00465 15.0215 9.09765 14.8833 9.16111 14.731C9.22457 14.5786 9.25724 14.4152 9.25724 14.2502C9.25724 14.0852 9.22457 13.9218 9.16111 13.7695C9.09765 13.6172 9.00465 13.4789 8.88749 13.3627L4.76249 9.25023H14.25C14.5815 9.25023 14.8995 9.11854 15.1339 8.88411C15.3683 8.64969 15.5 8.33175 15.5 8.00023C15.5 7.66871 15.3683 7.35077 15.1339 7.11635C14.8995 6.88193 14.5815 6.75023 14.25 6.75023Z"
                fill="#4D4D4D"
              />
            </svg>
            <!-- <img src="assets/img/back.svg" alt=""/> -->
          </div>
          <div id="question">
            <h2>Comment vous contacter ?</h2>
          </div>
        </div>
        <div class="blocInput groupReassurance">
          <div id="bInput" class="bInputContact bInputDaWithLabel">
            <div class="groupInput">
              <label for="">Téléphone</label>
              <input
                [(ngModel)]="personne.telephone"
                id="mts-telephone"
                (change)="changeTelephone($event)"
                placeholder="Téléphone"
                formControlName="phone"
                inputmode="numeric"
                maxlength="13"
                minlength="10"
                type="text"
              />

              <div
                *ngIf="
                  (phoneCtrl.invalid || telephoneInvalide()) &&
                  (phoneCtrl.dirty || phoneCtrl.touched)
                "
                class="alertcss child18"
              >
                Veuillez renseigner un téléphone valide.
                <!-- <span *ngIf="phoneCtrl.invalid && (phoneCtrl.dirty || phoneCtrl.touched)">Veuillez renseigner un téléphone valide.</span>
                  <span *ngIf="telephoneInvalide() && (phoneCtrl.dirty || phoneCtrl.touched)"> {{errorMessage}}</span> -->
              </div>
            </div>
            <br />

            <div class="groupInput">
              <label for="">Email</label>

              <input
                type="text"
                placeholder="Email"
                id="mts-mail"
                formControlName="email"
                (change)="changeMail($event)"
                [(ngModel)]="personne.email"
                (focus)="focusEmail()"
                (focusout)="focusOutEmail()"
              />

              <div
                [ngClass]="{
                  focusMailError: fMailError,
                  focusoutMailError: !fMailError,
                }"
                *ngIf="
                  emailInvalide(personne.email) || emailCtrl.hasError('pattern')
                "
                class="alertcss child18"
              >
                Veuillez renseigner un email valide.
              </div>

              <div
                *ngIf="emailCtrl.hasError('mailBroker')"
                class="alertcss child18"
              >
                L'adresse email doit être différent de celle de l'agence.
              </div>
            </div>
          </div>
          <div class="reassurance">
            <div class="reassuranceTitre">
              <span> 🤔 </span>
              <span> Pourquoi demandons-nous ces informations ?</span>
            </div>
            <div class="reassuranceLigne"></div>
            <div class="reassuranceContenu">
              <div class="reassuranceContenuRow">
                <div><img src="assets/img/Cup.svg" alt="" /></div>
                <div>
                  Pour <span>vous envoyer nos meilleures offres </span> par
                  email.
                </div>
              </div>
              <div class="reassuranceContenuRow">
                <div><img src="assets/img/CallCenter.svg" alt="" /></div>
                <div>
                  Pour pouvoir vous attribuer
                  <span>un conseiller dédié pour tous vos échanges. </span>
                </div>
              </div>
              <div class="reassuranceContenuRow">
                <div><img src="assets/img/LockTel.svg" alt="" /></div>
                <div>
                  Vos données ne seront <span>pas partagées </span> à des tiers.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="checkCall"
          (click)="onChangeInputEtreContacte(!inputEtreContacte.checked)"
        >
          <input
            #inputEtreContacte
            type="checkbox"
            name="inputEtreContacte"
            [checked]="personne.etre_contacte_par_telephone"
            (change)="onChangeInputEtreContacte(inputEtreContacte.checked)"
            style="width: 20px; height: 20px; margin-right: 10px"
          />
          Je souhaite être recontacté(e) par téléphone par un conseiller 
          Meilleurtaux Santé dans le cadre de ma demande de devis santé, 
          et je suis informé(e) que Meilleurtaux Santé peut également proposer des solutions de prévoyance.
        </div>
        <div class="checkCallWarning">
          <p>
            En cliquant sur «
            <span class="orange-text">Afficher les tarifs</span> », je créé un
            compte client Meilleurtaux
            <span *ngIf="textShowInOriginAffiliation()"
              >(Afi santé est une marque exploitée par AFI Assurances, société
              du groupe Meilleurtaux)</span
            >
            et accepte de recevoir des emails, conformément aux
            <a
              class="black-text underline"
              href="https://www.meilleurtaux.com/a-propos-de-meilleurtaux/mentions-legales/conditions-generales-utilisation-site.html"
              >conditions générales</a
            >
            , et accepte que mes
            <a
              class="black-text underline"
              href="https://www.meilleurtaux.com/a-propos-de-meilleurtaux/politique-de-confidentialite-afi.html?"
            >
              données personnelles</a
            >
            soient partagées au sein du Groupe Meilleurtaux.
          </p>
        </div>

        <div class="blocBoutton btnCoordonnées">
          <button
            id="nextButton"
            style="white-space: nowrap; width: auto"
            (click)="
              loading = true;
              getInputContact('Contact', personne.telephone, personne.email)
            "
            [ngClass]="{
              gray: true,
              orange:
                !phoneCtrl.invalid &&
                !telephoneInvalide() &&
                !emailCtrl.hasError('required') &&
                !emailCtrl.hasError('pattern') &&
                !emailCtrl.hasError('mailBroker') &&
                personne.email.length > 0 &&
                !emailInvalide(personne.email) &&
                personne.etre_contacte_par_telephone,
            }"
            [disabled]="
              !personne.etre_contacte_par_telephone ||
              phoneCtrl.invalid ||
              telephoneInvalide() ||
              emailCtrl.hasError('required') ||
              emailCtrl.hasError('pattern') ||
              emailCtrl.hasError('mailBroker') ||
              !personne.telephone ||
              personne.telephone.trim().length === 0 ||
              personne.email.length < 0 ||
              emailInvalide(personne.email)
            "
          >
            <div
              *ngIf="loading"
              class="spinner-border text-light"
              role="status"
            >
              <span class="sr-only">Traitement...</span>
            </div>
            Afficher les tarifs
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container-best-offers" *ngIf="isSlugQuoteRequest()">
    <div class="wrapp-element">
      <div class="best-offers">
        <div class="offer">
          <div class="container-title">
            <p class="head-title">Meilleure offre</p>
            <p class="content-title">Sénior</p>
          </div>
          <div class="offer-price">
            <p class="from">&Aacute; partir de</p>
            <p class="price-content">
              46,22&euro;<span class="min-text">/mois*</span>
            </p>
          </div>
        </div>

        <div class="offer">
          <div class="container-title">
            <p class="head-title">Meilleure offre</p>
            <p class="content-title">Couple sénior</p>
          </div>
          <div class="offer-price">
            <p class="from">&Aacute; partir de</p>
            <p class="price-content">
              82,08&euro;<span class="min-text">/mois**</span>
            </p>
          </div>
        </div>

        <div class="offer">
          <div class="container-title">
            <p class="head-title">Meilleure offre</p>
            <p class="content-title">Famille</p>
          </div>
          <div class="offer-price">
            <p class="from">&Aacute; partir de</p>
            <p class="price-content">
              54,01&euro;<span class="min-text">/mois***</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-good-reason" *ngIf="isSlugQuoteRequest()">
    <div class="wrapp-element">
      <div class="container-title-left">
        <p>
          <span class="blue">3 bonnes raisons</span> de choisir Meilleurtaux
          Santé
        </p>
      </div>
      <div class="container-article">
        <div class="gd-article">
          <div class="art-header">
            <img src="assets/img/img-article1.svg" alt="" />
          </div>
          <div class="art-title">Un accompagnement personnalisé</div>
          <div class="art-footer">pour chaque demande de devis</div>
        </div>

        <div class="gd-article">
          <div class="art-header">
            <img src="assets/img/img-article2.svg" alt="" />
          </div>
          <div class="art-title">Un interlocuteur unique</div>
          <div class="art-footer">dans tout le processus de souscription</div>
        </div>

        <div class="gd-article">
          <div class="art-header">
            <img src="assets/img/img-article3.svg" alt="" />
          </div>
          <div class="art-title">Des produits récompensés</div>
          <div class="art-footer">par le label excellence 2021</div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-mt-choosed" *ngIf="isSlugQuoteRequest()">
    <div class="wrapp-element">
      <div class="cont-title">
        <span class="blue">50 000 clients</span> ont choisi Meilleurtaux Santé
      </div>

      <div class="cont-over-scroll">
        <ngx-slick-carousel
          class="cont-art-cm s1"
          #slickModal="slick-carousel"
          [config]="slideConfig"
          (afterChange)="afterChange($event)"
        >
          <div ngxSlickItem class="art-cm">
            <div class="art-cm-head">
              <img src="assets/img/quote2.svg" alt="" />
              <p class="title-head">Trés satisfait</p>
            </div>
            <div class="art-cm-content">
              Très bon accueil téléphonique, sympathique et explicite dans vos
              explications. Très bon choix pour ma mutuelle. Un grand merci.
            </div>
            <div class="art-cm-foot">
              <div class="art-cm-star">
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
              </div>
              <div class="art-cm-message-foot">Hadj - Il y a 5 Heures</div>
            </div>
          </div>

          <div ngxSlickItem class="art-cm">
            <div class="art-cm-head">
              <img src="assets/img/quote2.svg" alt="" />
              <p class="title-head">Très bon accueil téléphonique</p>
            </div>
            <div class="art-cm-content">
              Réactivité de la conseillère qui sera notre contact en cas de
              besoin. Nous avons aussi apprécié son mode de fonctionnement :
              très structuré et organisé.
            </div>
            <div class="art-cm-foot">
              <div class="art-cm-star">
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
              </div>
              <div class="art-cm-message-foot">Charpigny - Il y a 2 Heures</div>
            </div>
          </div>

          <div ngxSlickItem class="art-cm">
            <div class="art-cm-head">
              <img src="assets/img/quote2.svg" alt="" />
              <p class="title-head">De bons conseils</p>
            </div>
            <div class="art-cm-content">
              Personne très agréable qui s’exprime très bien, elle m’a conseillé
              et expliqué les démarches pour conclure le dossier merci
            </div>
            <div class="art-cm-foot">
              <div class="art-cm-star">
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
                <div class="star">
                  <img src="assets/img/star2.svg" alt="" />
                </div>
              </div>
              <div class="art-cm-message-foot">Chopin - Il y a 3 Heures</div>
            </div>
          </div>
        </ngx-slick-carousel>
      </div>

      <div class="trustplot-div-cont">
        <div class="trustplot-div">
          <div class="on-star-and-text">
            <img src="assets/img/trustpilot-one-and-text.svg" alt="" />
          </div>
          <div class="five-star">
            <img src="assets/img/trustpilot-five-start.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-partner" *ngIf="isSlugQuoteRequest()">
    <div class="wrapp-element">
      <div class="container-title-part">
        <p>Nos partenaires assureurs</p>
      </div>
      <div class="cont-over-scroll">
        <ngx-slick-carousel
          class="container-partenar s2"
          #slickModal2="slick-carousel"
          [config]="slideConfig"
          (afterChange)="afterChange($event)"
        >
          <div ngxSlickItem class="partner img-malakoff">
            <img src="assets/img/partners/malakoff.svg" alt="" />
          </div>

          <div ngxSlickItem class="partner img-swisslife">
            <img src="assets/img/partners/swisslife.svg" alt="" />
          </div>
          <div ngxSlickItem class="partner img-alptis">
            <img src="assets/img/partners/alptis.svg" alt="" />
          </div>
          <div ngxSlickItem class="partner img-april">
            <img src="assets/img/partners/april.svg" alt="" />
          </div>
          <div ngxSlickItem class="partner img-neoliane">
            <img src="assets/img/partners/neoliane.svg" alt="" />
          </div>
        </ngx-slick-carousel>
      </div>

      <div class="container-btn-part">
        <a
          href="https://www.meilleurtaux.com/a-propos-de-meilleurtaux/nos-partenaires-assureurs/assurance-sante.html"
          target="_blank"
          class="dec-partners"
          >Découvrir tous nos partenaires</a
        >
      </div>
    </div>
  </div>

  <div *ngIf="isSlugQuoteRequest()">
    <div class="more-text" *ngIf="curentQuestion == 0">
      <div class="bloc-text">
        <div class="bloc-title">
          <div class="title">
            <span>
              <img src="assets/img/medical.svg" alt="Medical Icon" />
            </span>
            <b> Trouver la meilleure mutuelle santé avec un comparateur </b>
          </div>
        </div>
        <div class="bloc-container">
          <div class="bloc-container-text">
            <p>
              Optique, dentaire, hospitalisation, médicaments… Prendre soin de
              sa santé peut entrainer de lourdes dépenses.la Sécurité sociale
              assure une partie des remboursements sur certains postes de soins
              laissant un reste à charge parfois très élevé pour le patient. La
              souscription d’une complémentaire santé est indispensable pour
              vous protéger vous et votre famille.
            </p>
            <p>
              Avec le comparateur Meilleurtaux santé, accédez en quelques clics
              aux meilleures formules sélectionnées chez plus de 30 partenaires
              assureurs ! Le meilleur moyen pour trouver la mutuelle la moins
              chère et la plus adaptée à vos besoins. .
            </p>
          </div>
          <div class="bloc-container-title">
            Pourquoi souscrire une assurance complémentaire santé ?
          </div>
          <div class="bloc-container-text">
            <p>
              En France, les remboursements de soins et prestations des
              professionnels de santé sont assurés en premier lieu par le régime
              de l’Assurance maladie, universel et obligatoire.
            </p>
            <p>
              Ce dernier, cependant, ne compense pas entièrement les dépenses
              avancées par les patients pour leurs consultations médicales ou
              leurs achats de médicaments : la « base de remboursement » (BR) de
              la Sécurité sociale ne correspond souvent pas à la réalité du
              tarif facturé par le praticien.
            </p>
            <p>
              Dans le cas d’une visite classique chez un médecin généraliste
              conventionné, par exemple, le taux de remboursement proposé par
              l’Assurance maladie se limite à 60 % des honoraires du
              professionnel, sur la base d’un tarif de 25 €. Si le médecin
              pratique un dépassement d’honoraire, la part remboursée sera
              mécaniquement encore moins importante.
            </p>
            <p>
              Pour certains soins et équipements de santé, le tarif de base de
              la Sécurité sociale est, par ailleurs, extrêmement faible en
              comparaison du coût réel facturé par le professionnel. Citons par
              exemple :
            </p>
            <ul class="moretext-ul">
              <li>
                La pose d’une couronne céramo-métallique, remboursée à 60 % sur
                une base de 120€ seulement, soit un montant de 84€.
              </li>
              <li>
                L’achat d’une monture de lunettes pour adulte hors 100% santé,
                pris en charge à 60 % sur la base d’un tarif de… 0.05€.
              </li>
            </ul>
            <p>
              Dans le cadre de ces différents soins, pourtant très courants, un
              patient sans mutuelle s’expose ainsi à un reste à charge
              important.
            </p>
            <p>
              La souscription d’une mutuelle complémentaire permet une prise en
              charge totale ou partielle de ce ticket modérateur, pour soulager
              vos finances.
            </p>
          </div>
          <div class="bloc-container-title">
            Choisir sa mutuelle complémentaire chez Meilleurtaux
          </div>
          <div class="bloc-container-text">
            <p>
              La souscription de votre prochaine mutuelle santé via Meilleurtaux
              vous apporte de nombreux avantages et vous fait bénéficier d’un
              service expert pour faire le meilleur choix.
            </p>
          </div>
          <div class="bloc-container-title">
            Un accompagnement personnalisé avec interlocuteur unique
          </div>
          <div class="bloc-container-text">
            <p>
              Quelles sont les garanties à privilégier en fonction de votre état
              de santé ou de la situation de votre famille ? Quels sont les
              postes de soins sur lesquels vous pourriez bénéficier d’une
              meilleure protection ? Les 250 conseillers de Meilleurtaux Santé
              sont à votre disposition pour vous informer et vous accompagner
              dans vos démarches de recherche de la meilleure mutuelle.
            </p>
            <p>
              Tous les clients Meilleurtaux peuvent bénéficier d’un suivi
              individualisé de leur dossier par un conseiller dédié.
            </p>
          </div>
          <div class="bloc-container-title">
            Une assurance aux meilleures conditions
          </div>
          <div class="bloc-container-text">
            <p>
              Meilleurtaux vous donne accès à l’offre de plus de 30 compagnies
              d’assurance, incluant par exemple :
            </p>
            <ul class="moretext-ul">
              <li>Apivia Mutuelle</li>
              <li>April</li>
              <li>CEGEMA</li>
              <li>Malakoff Humanis</li>
              <li>SwissLife</li>
              <li>Alptis</li>
              <li>Néoliane...</li>
            </ul>
            <p>
              Ce choix sans équivalent vous permet d’affiner votre recherche de
              façon considérable pour sélectionner uniquement les contrats les
              plus adaptés, à des tarifs négociés. Grâce au comparateur
              Meilleurtaux, retenez l’ensemble des critères pertinents et
              procédez à un tri instantané en fonction du prix.
            </p>
          </div>
          <div class="bloc-container-title">
            Des démarches simplifiées de résiliation
          </div>
          <div class="bloc-container-text">
            <p>
              Vous souhaitez obtenir de l’aide pour procéder à la souscription
              d’une nouvelle mutuelle, mais aussi à la résiliation d’un
              précédent contrat ? Meilleurtaux vous permet de bénéficier en
              toute simplicité des nouvelles possibilités de résiliation
              apportées par la loi : procédez à l’interruption de votre ancienne
              formule à tout moment, sans frais ni pénalité, dès qu’elle a plus
              d’un an d’ancienneté !
            </p>
          </div>
          <div class="bloc-container-title">Des produits récompensés</div>
          <div class="bloc-container-text">
            <p>
              50 000 clients nous font déjà confiance et bénéficient d’un accès
              privilégié à des dizaines de mutuelles santé pour tous âges et
              tous profils. Avec ses nombreux conseillers à l’écoute constante
              de vos besoins, ses conditions tarifaires négociées et son
              comparateur avancé, le produit Immédiat 100% santé de Meilleurtaux
              Santé a obtenu le label Excellence au titre de l’année 2022.
            </p>
          </div>
          <div class="bloc-container-title">
            Découvrez le comparateur de mutuelle santé Meilleurtaux
          </div>
          <div class="bloc-container-title">
            Quel est l’intérêt d’utiliser un comparateur de complémentaire
            santé ?
          </div>
          <div class="bloc-container-text">
            <p>
              Pourquoi passer votre temps précieux à consulter et comparer
              manuellement les formules santé de plusieurs assureurs ? Un
              comparateur en ligne est désormais en mesure de remplir cette
              tâche à votre place et de manière bien plus efficace, en agrégeant
              l’offre de dizaines de compagnies d’assurance en temps réel. Plus
              besoin de vous rendre en agence ou de scruter les moindres détails
              de chaque grille tarifaire.
            </p>
            <p>
              Les comparateurs de mutuelle de nouvelle génération autorisent une
              recherche détaillée pour prendre en compte tous les éléments
              importants de chaque contrat. Examinez d’un seul coup d’œil :
            </p>
            <ul class="moretext-ul">
              <li>
                Le taux de remboursement pour chaque garantie, exprimé en
                pourcentage ou en base forfaitaire.
              </li>
              <li>
                Le montant de la cotisation mensuelle ou annuelle, à niveau de
                garantie équivalent.
              </li>
              <li>
                Le montant éventuel des franchises, susceptibles de réduire
                votre indemnisation effective en cas de consultation médicale ou
                hospitalisation.
              </li>
              <li>
                Le plafond de garantie (le cas échéant) ou, par exemple, le
                nombre d’actes de prévention offerts dans l’année…
              </li>
            </ul>
            <p>
              En plus des facilités de recherche, le comparateur d’une grande
              plateforme de courtier comme Meilleurtaux vous fait bénéficier
              automatiquement de prix négociés. Vous trouverez ainsi des
              conditions tarifaires nettement plus attractives qu’en contactant
              directement un assureur de votre choix. Il vous suffit ensuite de
              suivre le lien proposé par le comparateur pour entamer le
              processus de souscription en ligne.
            </p>
          </div>
          <div class="bloc-container-title">
            Comment choisir la meilleure offre pour votre protection santé ?
          </div>
          <div class="bloc-container-text">
            <p>
              Le choix d’une mutuelle complémentaire santé ne doit pas
              s’improviser. Vous devrez notamment accorder votre attention à
              certains postes et catégories de soins parmi les plus coûteux et
              sensibles, dont :
            </p>
            <p>
              Les soins dentaires (prothèses et implants, appareillage dentaire,
              consultations de routine chez le dentiste) ;<br />
              Les soins et équipements optiques (consultations chez
              l’ophtalmologue, monture et verres de lunettes, lentilles de
              contact…) ;<br />
              La consultation de médecins généralistes ou spécialistes avec
              dépassement d’honoraires ;<br />
              Les séjours en hospitalisation (forfait journalier, suppléments
              confort pour télévision ou chambre individuelle…) ;<br />
              Les actes de médecine de prévention (kinésithérapie,
              ostéopathie…).
            </p>
            <p>
              Prenez le temps de faire le point sur votre situation individuelle
              et vos besoins de santé à court, moyen et long terme.
            </p>
          </div>
          <div class="bloc-container-title">
            Quel prix pour votre mutuelle santé ?
          </div>
          <div class="bloc-container-text">
            <p>
              Le tarif d’une complémentaire santé peut être influencé par un
              grand nombre de facteurs. Il dépend notamment :
            </p>
            <ul class="moretext-ul">
              <li>Du niveau des garanties souscrites et de leur nombre.</li>
              <li>
                De l’âge de l’assuré au moment de la souscription du contrat,
                une surprime étant susceptible de s’appliquer pour les
                souscripteurs les plus âgés.
              </li>
              <li>
                Du nombre d’ayants-droits à inscrire au contrat (conjoint,
                enfants, autres personnes à charge dans le foyer…)
              </li>
              <li>
                De la politique commerciale de l’assureur, plus ou moins
                avantageuse.
              </li>
              <li>Des délais de carence imposés dans le contrat...</li>
            </ul>
            <p>
              Vous recherchez des mutuelles pas chères ? Contactez Meilleurtaux
              Santé et consultez, dès maintenant, les offres les plus
              intéressantes via notre outil de comparaison de complémentaires
              santé en ligne.
            </p>
          </div>
        </div>
      </div>
      <div class="bloc-text">
        <div class="bloc-title">
          <div class="title">
            <span>
              <img src="assets/img/medical.svg" alt="" />
            </span>
            <b>
              Quelles sont les principales étapes pour changer de mutuelle ?
            </b>
          </div>
        </div>
        <div class="bloc-container">
          <div class="bloc-container-text">
            <p>
              À la recherche d’une mutuelle auprès d’une nouvelle compagnie
              d’assurance pour payer moins cher ? Avec Meilleurtaux, le
              processus est très facile ! Trois étapes simples sont à respecter.
            </p>
          </div>
          <div class="bloc-container-title">
            <span>1.</span> Faites le point sur vos besoins de santé
          </div>
          <div class="bloc-container-text">
            <p>
              La meilleure complémentaire ne sera pas nécessairement la même
              pour tous les profils. Il convient de choisir le contrat offrant
              le meilleur rapport entre le prix, la qualité des garanties et vos
              propres besoins. Ces derniers peuvent notamment évoluer en
              fonction de votre situation personnelle et de votre âge :
            </p>
            <ul class="moretext-ul">
              <li>
                Les jeunes actifs et couples sans enfant peuvent s’orienter vers
                une mutuelle individuelle proposant des garanties de base, pour
                la couverture des plus gros risques au tarif le plus bas.
              </li>
              <li>
                Une mutuelle familiale inclut typiquement des garanties
                renforcées pour l’ensemble du foyer concernant les postes de
                soins les plus coûteux (optique, dentaire…).
              </li>
              <li>
                Une mutuelle senior est spécifiquement conçue pour les besoins
                de santé des retraités et des personnes âgées. Ces contrats,
                souvent plus haut de gamme, peuvent proposer des remboursements
                attractifs pour certaines prestations, comme la médecine de
                prévention ou encore les prothèses auditives.
              </li>
            </ul>
            <p>
              Quel que soit votre profil, la plateforme Meilleurtaux est en
              mesure de vous aider et de vous accompagner dès cette première
              étape. Contactez notre ligne téléphonique dédiée au 01 83 77 57
              30.
            </p>
          </div>
          <div class="bloc-container-title">
            <span>2.</span> Consultez notre comparateur de mutuelles santé
          </div>
          <div class="bloc-container-text">
            <p>
              Le comparateur de complémentaire santé Meilleurtaux est l’outil de
              référence pour trouver rapidement l’offre qui vous convient.
              Quelques minutes suffiront pour obtenir un devis mutuelle et le
              détail complet selon les niveaux de garanties. Vous devrez
              notamment renseigner :
            </p>
            <ul class="moretext-ul">
              <li>
                Votre identité (nom, prénom, coordonnées, date de naissance…).
              </li>
              <li>
                Votre situation familiale (nombre de personnes dans le foyer et
                à assurer, avec pour chacun l’âge et le régime social
                applicable…).
              </li>
              <li>
                Votre situation professionnelle (type de profession, adhérent à
                une mutuelle d’entreprise ou non…).
              </li>
              <li>
                Le cas échéant, la date de souscription de votre contrat actuel
                et le nom de l’assureur.
              </li>
              <li>
                Le niveau de garantie souhaité (basique, intermédiaire, confort
                ou premium…).
              </li>
              <li>
                Les postes de soins renforcés et à privilégier (dentaire,
                prévention, lunettes et lentilles de contact…).
              </li>
            </ul>
            <p>
              Depuis le comparateur en ligne d’assurance santé, vous pourrez
              ensuite souscrire directement votre nouveau contrat. Avec
              Meilleurtaux, les démarches sont particulièrement rapides et
              peuvent être réalisées :
            </p>
            <ul class="moretext-ul">
              <li>En ligne</li>
              <li>Au téléphone</li>
              <li>Par e-mail</li>
            </ul>
          </div>
          <div class="bloc-container-title">
            <span>3.</span> Résiliez votre mutuelle santé précédente
          </div>
          <div class="bloc-container-text">
            <p>
              Il est préférable d’avoir déjà trouvé votre prochaine
              complémentaire santé avant d’enclencher la résiliation du contrat
              précédent… D’autant plus que la démarche est désormais beaucoup
              plus souple ! Depuis le 1er décembre 2020, et en vertu de la loi
              n°2019-733 du 14 juillet 2019, un assuré peut interrompre sa
              mutuelle à tout moment après la date de son premier anniversaire.
            </p>
            <p>
              Ce droit est accordé sans justification ni frais : l’assuré n’a
              donc pas à motiver sa décision. Les modalités exactes peuvent
              varier selon les compagnies d’assurance, et inclure l’envoi d’une
              lettre de résiliation. Consultez les conditions générales de votre
              contrat pour en savoir plus.
            </p>
          </div>
        </div>
      </div>
      <div class="bloc-text">
        <div class="bloc-title">
          <div class="title">
            <span>
              <img src="assets/img/medical.svg" alt="" />
            </span>
            <b> Vos questions sur la mutuelle santé </b>
          </div>
        </div>
        <div class="bloc-container">
          <div class="bloc-container-title">
            <span>1.</span> Qu’est-ce qu’une mutuelle santé responsable ?
          </div>
          <div class="bloc-container-text">
            <p>
              Les contrats de complémentaire santé bénéficiant du label
              « responsable » prévoient de laisser un reste à charge minimal
              (ticket modérateur) à l’assuré afin de le responsabiliser sur ses
              dépenses de soins. En contrepartie, ils profitent d’un traitement
              fiscal plus favorable et affichent donc des tarifs plus avantageux
              qu’un contrat non responsable.
            </p>
          </div>
          <div class="bloc-container-title">
            <span>2.</span> Quel est l’intérêt d’une mutuelle santé avec tiers
            payant ?
          </div>
          <div class="bloc-container-text">
            <p>
              Le tiers payant est un système de télétransmission instantanée des
              données de l’assuré en cas de consultation médicale ou achat de
              médicament. Il permet au professionnel de santé d’être payé
              immédiatement par l’assureur, en fonction des taux prévus dans le
              contrat de mutuelle. L’assuré n’a donc plus à avancer les frais,
              ce qui représente pour lui un gain net de trésorerie.
            </p>
          </div>
          <div class="bloc-container-title">
            <span>3.</span> Quelles sont les aides à la souscription d’une
            mutuelle santé ?
          </div>
          <div class="bloc-container-text">
            <p>
              Plusieurs aides publiques permettent à certains assurés de
              financer tout ou partie de leur complémentaire santé. Il s’agit
              notamment :
            </p>
            <ul class="moretext-ul">
              <li>
                De la Complémentaire Santé Solidaire (CSS), destinée notamment
                aux ménages les plus modestes.
              </li>
              <li>
                Du chèque santé, pour les salariés en contrat de travail de
                courte durée ou à temps partiel.
              </li>
              <li>
                De l’Aide Médicale d’État (AME), pour les personnes de
                nationalité étrangère.
              </li>
            </ul>
            <b>
              Une mutuelle apporte une couverture complémentaire et
              indispensable pour la maîtrise de votre budget santé. Meilleurtaux
              Santé met à votre disposition son comparateur d’assurance santé en
              ligne pour vous aider à choisir les meilleures garanties aux
              meilleures conditions.
            </b>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    [ngClass]="{
      'container-m-legale': true,
      raiseBottom: showView('EnfantsDateNaissance'),
    }"
    *ngIf="isSlugQuoteRequest()"
  >
    <div class="wrapp-element">
      <div class="m-header-m-legale">Mentions légales</div>
      <div class="cont-m-legale">
        <div class="m-legale">
          *Tarif valable pour une personne de 56 ans située à Melun (77) avec
          une formule F1 sur le produit Liberté NR Kéréis / régime sécurité
          sociale / date d’effet 2025. Tarif généré le 07/03/2025. Ce tarif est
          disponible uniquement en ayant un conseiller santé au téléphone et non
          disponible en ligne sur notre tunnel de comparaison.
        </div>
        <div class="m-legale">
          **Tarif valable pour un couple sénior de 56 ans située à Melun (77)
          avec une formule F1 sur le produit Liberté NR Kéréis / régime sécurité
          sociale / date d’effet 2025. Tarif généré le 07/03/2025. Ce tarif est
          disponible uniquement en ayant un conseiller santé au téléphone et non
          disponible en ligne sur notre tunnel de comparaison.
        </div>
        <div class="m-legale">
          ***Tarif valable pour une famille monoparentale avec un adulte de 35
          ans et un enfant de 9 ans située à Melun (77) - formule F1 sur le
          produit Alto Santé Néoline NR / régime sécurité sociale / date d’effet
          2025. Tarif généré le 07/03/2025. Ce tarif est disponible uniquement
          en ayant un conseiller santé au téléphone et non disponible en ligne
          sur notre tunnel de comparaison.
        </div>
        <div
          class="m-legale"
          *ngIf="verifyDateCreaEconomie('2024-04-26', '2024-06-28')"
        >
          <sup><b>1</b></sup> Le 2ème mois de cotisation est remboursé (1 mois
          offert). Jusqu’au 30 juin 2024, pour toute souscription d’un contrat
          Progression Santé Sénior ou Immédiat Santé Sénior, le client
          bénéficiera du remboursement de son 2ème mois de cotisation.
        </div>
        <div
          class="m-legale"
          *ngIf="!verifyDateCreaEconomie('2024-04-26', '2024-06-28')"
        >
          <sup><b>1</b></sup> 399€/an d'économies - Les clients n’ayant pas
          augmenté leur garantie économisent en moyenne 399,60€ par an par
          rapport à leur précédent contrat. Étude réalisée du 29/01/2025 au
          10/02/2025 sur nos nouveaux clients. Résultats basés sur 468
          répondants à l’enquête. Détail de l’étude disponible sur simple
          demande à l’adresse
          <a
            href="mailto:dpo-sante@meilleurtaux.com"
            class="black-text underline"
            ><u class="u_email">dpo-sante&#64;meilleurtaux.com</u></a
          >
        </div>
        <div class="m-legale" *ngIf="isParrainLink()">
          (1)En souscrivant à l’une de nos offres, vous bénéficierez d’un chèque
          cadeau de 20€ dans le cadre du parrainage.
          <a
            href="https://www.meilleurtaux.com/images/Meilleurtaux_sante/reglement/reglement_parrainage.pdf"
            target="_blank"
            >voir conditions</a
          >
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isSlugQuoteRequest()" class="footer">
    <wz-footer-demande-devis></wz-footer-demande-devis>
  </div>

  <div *ngIf="curentQuestion == 0" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNext01"></ng-container>
  </div>

  <div *ngIf="curentQuestion == 1" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNext02"></ng-container>
  </div>

  <div *ngIf="curentQuestion == 200" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNext03"></ng-container>
  </div>

  <div *ngIf="showView('DateNaissance')" class="blocBouttonmobile">
    <ng-container
      *ngTemplateOutlet="
        contentNextDN;
        context: { $implicit: inputDateNaissanceAssure }
      "
    ></ng-container>
  </div>

  <div *ngIf="showView('RegimeSocial')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextRS"></ng-container>
  </div>

  <div *ngIf="showView('ConjointDateNaissance')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextCDN"></ng-container>
  </div>

  <div *ngIf="showView('ConjointRegimeSocial')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextCRS"></ng-container>
  </div>

  <div
    *ngIf="
      showView('EnfantsDateNaissance') &&
      dateNaissanceEnfant().controls.length > 0
    "
    class="blocBouttonmobile"
  >
    <button
      [disabled]="checkChildAny26()"
      id="nextButton"
      class="gray"
      [ngClass]="{
        gray: checkChildAny26(),
        orange: !checkChildAny26(),
      }"
      (click)="getInputDateNaissanceEnfants('EnfantsDateNaissance')"
    >
      Suivant
      <img src="assets/img/next.svg" alt="" />
    </button>
  </div>

  <div *ngIf="showView('DateDebutContrat')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextDC"></ng-container>
  </div>

  <div *ngIf="showView('NiveauRemboursement')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextNivRemb"></ng-container>
  </div>

  <div *ngIf="showView('NomPrenom')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextNomPrenom"></ng-container>
  </div>

  <div *ngIf="showView('Departement')" class="blocBouttonmobile">
    <ng-container *ngTemplateOutlet="contentNextDep"></ng-container>
  </div>

  <mat-form-field style="display: none">
    <wz-date-input
      formControlName="dateNaissance"
      placeholder="Date de naissance"
    ></wz-date-input>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('majorPerson')"
      wzI18n="FORMS_BIRTHDAY_MAJORPERSON"
    ></mat-error>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('required')"
      wzI18n="FORMS_BIRTHDAY_REQUIRED"
    ></mat-error>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('max')"
      wzI18n="FORMS_BIRTHDAY_MIN"
      [wzI18nParams]="minAge"
    >
    </mat-error>
    <mat-error
      *ngIf="dateNaissanceCtrl.hasError('min')"
      wzI18n="FORMS_BIRTHDAY_MAX"
      [wzI18nParams]="maxAge"
    >
    </mat-error>
    <mat-hint><span wzI18n="FORMS_DATE_HINT"></span></mat-hint>
  </mat-form-field>

  <mat-form-field style="display: none">
    <wz-date-input
      formControlName="dateEffet"
      placeholder="Date d'effet"
    ></wz-date-input>
    <mat-error *ngIf="dateEffectCtrl.hasError('required')"
      >La date d'effet est obligatoire.</mat-error
    >
    <mat-error *ngIf="dateEffectCtrl.hasError('min')"
      >La date d'effet doit être égale ou postérieure à
      {{ healthEffectDateMin | date }}
    </mat-error>
    <mat-error *ngIf="dateEffectCtrl.hasError('max')"
      >La date d'effet ne peut pas être supérieur à an.
    </mat-error>
    <mat-hint>
      <span wzI18n="FORMS_DATE_HINT"></span>
    </mat-hint>
  </mat-form-field>

  <wz-button-toggle
    style="display: none"
    title="Régime social *"
    enumItemsKey="REGIME_SOCIAL_ENUM"
    formControlName="regimeSocial"
    [fullWidth]="true"
    orientation="row"
  >
  </wz-button-toggle>
  <mat-error
    *ngIf="regimeSocialCtrl.dirty && regimeSocialCtrl.hasError('required')"
    >Le régime social doit être renseigné
  </mat-error>
</form>

<div id="footer-lp" *ngIf="isSlugOriginParam()">
  <!-- FOOTER AFI SANTE -->
  <div
    class="footer-afi-sante"
    *ngIf="currentFooter === 'afisante_affiliation'"
  >
    <div class="wave-container">
      <img
        src="../../../../../../assets/img/wave.svg"
        alt=""
        srcset=""
        class="wave"
      />
    </div>
    <div class="footer-afi-sante__content">
      <div class="footer-afi-sante__content__first">
        <p>
          <strong>AFI Santé</strong> est une marque exploitée par<strong>
            AFI Assurances</strong
          >&nbsp;(société du <strong>Groupe </strong>
          <strong>Meilleurtaux</strong>) –&nbsp;SAS au capital de 10 000€
          –&nbsp;12 rue du Bois Guillaume <br />– 91055 Evry Courcouronnes Cedex
          – RCS Evry 404 414 583&nbsp;
        </p>
        <p>
          Courtier en assurance ORIAS n°&nbsp;07 027 969 (<a
            href="https://www.orias.fr/"
            class="link"
            >www.orias.fr)</a
          >&nbsp;soumise au contrôle de l’ACPR (Autorité de Contrôle Prudentiel
          et de Résolution – 4 place de Budapest, CS 75 436 Paris Cedex 09)
        </p>
      </div>
      <div class="footer-afi-sante__content__second">
        <p>
          <em
            ><sup><b>1</b></sup
            >&nbsp;Montant moyen économisé par les clients du produit de
            complémentaire santé « Evoluo » pour l’année 2023. Etude réalisée du
            01/01/2022 au 31/12/2022 sur un échantillon d’environ 263 personnes
            déjà clientes auprès de Meilleurtaux santé et souhaitant réaliser
            des économies – détail de l’étude disponible sur simple demande à
            l’adresse&nbsp;<a
              class="black-text underline link"
              href="mailto:dpo-sante@meilleurtaux.com"
              ><u class="u_email">dpo-sante&#64;meilleurtaux.com</u></a
            ></em
          >
        </p>
        <p>
          Les informations recueillies dans le formulaire sont enregistrées dans
          un fichier informatisé par&nbsp;<strong>AFI Assurances</strong>
          –&nbsp;La base légale du traitement est le consentement. Les données
          collectées seront communiquées aux seuls destinataires suivants :
          service commercial AFI assurances.&nbsp;Elles sont conservées pendant
          3 (trois) ans à compter du jour de leur collecte.
        </p>
        <p>
          Vous pouvez accéder aux données vous concernant, les rectifier,
          demander leur effacement ou exercer votre droit à la limitation du
          traitement de vos données. Vous pouvez retirer à tout moment votre
          consentement au traitement de vos données.&nbsp;Vous pouvez également
          vous opposer au traitement de vos données et exercer votre droit à la
          portabilité de vos données.
        </p>
        <p>
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez contacter notre DPO
          (délégué à la protection des données) :&nbsp;<a
            class="link"
            href="mailto:dpo-afi@afiassurances.fr"
            class="link"
            >dpo-afi&#64;afiassurances.fr</a
          >.&nbsp;
        </p>
        <p>
          Si vous estimez, après nous avoir contactés, que vos droits «
          Informatique et Libertés » ne sont pas respectés, vous pouvez adresser
          une réclamation à la CNIL.&nbsp;Nous vous informons du droit de vous
          inscrire sur la liste d’opposition au démarchage téléphonique
          “Bloctel”, sur laquelle vous pouvez vous inscrire ici :&nbsp;<a
            class="link"
            href="https://conso.bloctel.fr/"
            >https://conso.bloctel.fr.</a
          >
        </p>
      </div>
    </div>
  </div>

  <!-- FOOTER Mutuelle.com -->
  <div
    class="footer-mutuelle-com"
    *ngIf="currentFooter === 'Mutuelle.com_affiliation'"
  >
    <div class="wave-container">
      <img
        src="../../../../../../assets/img/wave.svg"
        alt=""
        srcset=""
        class="wave"
      />
    </div>
    <div class="footer-mutuelle-com__content">
      <div class="footer-mutuelle-com__content__first">
        <p>
          <strong>Mutuelle.com </strong>est une marque exploitée par
          <strong>AFI Assurances&nbsp;</strong
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >(</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >société du<b> Groupe Meilleurtaux</b>) –</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >&nbsp;</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >SAS au capital de 10 000€ –&nbsp;</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >12 rue du Bois Guillaume <br />– 91055 Evry Courcouronnes Cedex –
            RCS Evry 404 414 583&nbsp;</span
          >
        </p>
        <p>
          <span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >Courtier en assurance ORIAS n°</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;07 027 969 (</span
          ><a
            href="https://www.orias.fr/"
            target="_blank"
            rel="noopener"
            class="link"
            >www.orias.fr)</a
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;soumise au contrôle de l’ACPR (Autorité de Contrôle
            Prudentiel et de Résolution – 4 place de Budapest, CS 75 436 Paris
            Cedex 09)</span
          >
        </p>
      </div>
      <div class="footer-mutuelle-com__content__second">
        <p>
          <strong
            ><em><sup>1</sup></em></strong
          ><em
            >&nbsp;Montant moyen économisé par les clients du produit de
            complémentaire santé « Evoluo » pour l’année 2023. Etude réalisée du
            01/01/2022 au 31/12/2022 sur un échantillon d’environ 263 personnes
            déjà clientes auprès de Meilleurtaux santé et souhaitant réaliser
            des économies – détail de l’étude disponible sur simple demande à
            l’adresse&nbsp;<a
              href="mailto:dpo-sante@meilleurtaux.com"
              class="link"
              >dpo-sante&#64;meilleurtaux.com</a
            ></em
          >
        </p>
        <p>
          Les informations recueillies dans le formulaire sont enregistrées dans
          un fichier informatisé par&nbsp;<strong>AFI Assurances</strong>
          –&nbsp;La base légale du traitement est le consentement. Les données
          collectées seront communiquées aux seuls destinataires suivants :
          service commercial AFI assurances.&nbsp;Elles sont conservées pendant
          3 (trois) ans à compter du jour de leur collecte.
        </p>
        <p>
          Vous pouvez accéder aux données vous concernant, les rectifier,
          demander leur effacement ou exercer votre droit à la limitation du
          traitement de vos données. Vous pouvez retirer à tout moment votre
          consentement au traitement de vos données.&nbsp;Vous pouvez également
          vous opposer au traitement de vos données et exercer votre droit à la
          portabilité de vos données.
        </p>
        <p>
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez contacter notre DPO
          (délégué à la protection des données) :&nbsp;<a
            href="mailto:dpo-afi@afiassurances.fr"
            class="link"
            >dpo-afi&#64;afiassurances.fr</a
          >.&nbsp;
        </p>
        <p>
          Si vous estimez, après nous avoir contactés, que vos droits «
          Informatique et Libertés » ne sont pas respectés, vous pouvez adresser
          une réclamation à la CNIL.&nbsp;Nous vous informons du droit de vous
          inscrire sur la liste d’opposition au démarchage téléphonique
          “Bloctel”, sur laquelle vous pouvez vous inscrire ici :&nbsp;<a
            href="https://conso.bloctel.fr/"
            class="link"
            >https://conso.bloctel.fr.</a
          >
        </p>
      </div>
    </div>
  </div>

  <!-- FOOTER La bonne mutuelle -->
  <div
    class="footer-la-bonne-mutuelle"
    *ngIf="currentFooter === 'labonnemutuelle_affiliation'"
  >
    <div class="wave-container">
      <img
        src="../../../../../../assets/img/wave.svg"
        alt=""
        srcset=""
        class="wave"
      />
    </div>
    <div class="footer-mutuelle-com__content">
      <div class="footer-mutuelle-com__content__first">
        <p>
          <strong>La Bonne Mutuelle </strong>est une marque exploitée par<strong>
            AFI Assurances&nbsp;</strong
          >(société du<strong> Groupe Meilleurtaux</strong>) –&nbsp;SAS au
          capital de 10 000€ –&nbsp;12 rue du Bois Guillaume <br />– 91055 Evry
          Courcouronnes Cedex – RCS Evry 404 414 583&nbsp;
        </p>
        <p>
          <span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >Courtier en assurance ORIAS n°</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;07 027 969 (</span
          ><a
            href="https://www.orias.fr/"
            target="_blank"
            rel="noopener"
            class="link"
            >www.orias.fr)</a
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;soumise au contrôle de l’ACPR (Autorité de Contrôle
            Prudentiel et de Résolution – 4 place de Budapest, CS 75 436 Paris
            Cedex 09)</span
          >
        </p>
      </div>
      <div class="footer-mutuelle-com__content__second">
        <p>
          <em><sup>1</sup></em
          ><em
            >&nbsp;Montant moyen économisé par les clients du produit de
            complémentaire santé « Evoluo » pour l’année 2023. Etude réalisée du
            01/01/2022 au 31/12/2022 sur un échantillon d’environ 263 personnes
            déjà clientes auprès de Meilleurtaux santé et souhaitant réaliser
            des économies – détail de l’étude disponible sur simple demande à
            l’adresse&nbsp;<a
              href="mailto:dpo-sante@meilleurtaux.com"
              class="link"
              >dpo-sante&#64;meilleurtaux.com</a
            ></em
          >
        </p>
        <p>
          Les informations recueillies dans le formulaire sont enregistrées dans
          un fichier informatisé par&nbsp;<strong>AFI Assurances</strong
          >&nbsp;–&nbsp;La base légale du traitement est le consentement. Les
          données collectées seront communiquées aux seuls destinataires
          suivants : service commercial AFI assurances.&nbsp;Elles sont
          conservées pendant 3 (trois) ans à compter du jour de leur collecte.
        </p>
        <p>
          Vous pouvez accéder aux données vous concernant, les rectifier,
          demander leur effacement ou exercer votre droit à la limitation du
          traitement de vos données. Vous pouvez retirer à tout moment votre
          consentement au traitement de vos données.&nbsp;Vous pouvez également
          vous opposer au traitement de vos données et exercer votre droit à la
          portabilité de vos données.
        </p>
        <p>
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez contacter notre DPO
          (délégué à la protection des données) :&nbsp;<a
            href="mailto:dpo-afi@afiassurances.fr"
            class="link"
            >dpo-afi&#64;afiassurances.fr</a
          >.&nbsp;
        </p>
        <p>
          Si vous estimez, après nous avoir contactés, que vos droits «
          Informatique et Libertés » ne sont pas respectés, vous pouvez adresser
          une réclamation à la CNIL.&nbsp;Nous vous informons du droit de vous
          inscrire sur la liste d’opposition au démarchage téléphonique
          “Bloctel”, sur laquelle vous pouvez vous inscrire ici :&nbsp;<a
            href="https://conso.bloctel.fr/"
            class="link"
            >https://conso.bloctel.fr.</a
          >
        </p>
      </div>
    </div>
  </div>

  <!-- FOOTER La assurance et mutuelle -->
  <div
    class="footer-la-assurance-et-mutuelle"
    *ngIf="currentFooter === 'assuranceetmutuelle_affiliation'"
  >
    <div class="wave-container">
      <img
        src="../../../../../../assets/img/wave.svg"
        alt=""
        srcset=""
        class="wave"
      />
    </div>
    <div class="footer-mutuelle-com__content">
      <div class="footer-mutuelle-com__content__first">
        <p>
          <strong>Assurance &amp; Mutuelle </strong>est une marque exploitée
          par<strong> AFI Assurances&nbsp;</strong>(<span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >société du <b>Groupe Meilleurtaux</b>) –</span
          ><span
            style="
              font-weight: bold;
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >&nbsp;</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >SAS au capital de 10 000€ –&nbsp;</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >12 rue du Bois Guillaume <br />– 91055 Evry Courcouronnes Cedex –
            RCS Evry 404 414 583&nbsp;</span
          >
        </p>
        <p>
          <span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >Courtier en assurance ORIAS n°</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;07 027 969 (</span
          ><a
            href="https://www.orias.fr/"
            target="_blank"
            rel="noopener"
            class="link"
            >www.orias.fr)</a
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;soumise au contrôle de l’ACPR (Autorité de Contrôle
            Prudentiel et de Résolution – 4 place de Budapest, CS 75 436 Paris
            Cedex 09)</span
          >
        </p>
      </div>
      <div class="footer-mutuelle-com__content__second">
        <p>
          <em><sup>1</sup></em
          ><em
            >&nbsp;Montant moyen économisé par les clients du produit de
            complémentaire santé « Evoluo » pour l’année 2023. Etude réalisée du
            01/01/2022 au 31/12/2022 sur un échantillon d’environ 263 personnes
            déjà clientes auprès de Meilleurtaux santé et souhaitant réaliser
            des économies – détail de l’étude disponible sur simple demande à
            l’adresse&nbsp;<a
              href="mailto:dpo-sante@meilleurtaux.com"
              class="link"
              >dpo-sante&#64;meilleurtaux.com</a
            ></em
          >
        </p>
        <p>
          Les informations recueillies dans le formulaire sont enregistrées dans
          un fichier informatisé par&nbsp;<strong>AFI Assurances</strong
          >&nbsp;–&nbsp;La base légale du traitement est le consentement. Les
          données collectées seront communiquées aux seuls destinataires
          suivants : service commercial AFI assurances.&nbsp;Elles sont
          conservées pendant 3 (trois) ans à compter du jour de leur collecte.
        </p>
        <p>
          Vous pouvez accéder aux données vous concernant, les rectifier,
          demander leur effacement ou exercer votre droit à la limitation du
          traitement de vos données. Vous pouvez retirer à tout moment votre
          consentement au traitement de vos données.&nbsp;Vous pouvez également
          vous opposer au traitement de vos données et exercer votre droit à la
          portabilité de vos données.
        </p>
        <p>
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez contacter notre DPO
          (délégué à la protection des données) :&nbsp;<a
            href="mailto:dpo-afi@afiassurances.fr"
            class="link"
            >dpo-afi&#64;afiassurances.fr</a
          >.&nbsp;
        </p>
        <p>
          Si vous estimez, après nous avoir contactés, que vos droits «
          Informatique et Libertés » ne sont pas respectés, vous pouvez adresser
          une réclamation à la CNIL.&nbsp;Nous vous informons du droit de vous
          inscrire sur la liste d’opposition au démarchage téléphonique
          “Bloctel”, sur laquelle vous pouvez vous inscrire ici :&nbsp;<a
            href="https://conso.bloctel.fr/"
            class="link"
            >https://conso.bloctel.fr.</a
          >
        </p>
      </div>
    </div>
  </div>

  <!-- FOOTER Mutuelle online -->
  <div
    class="footer-mutuelle-online"
    *ngIf="currentFooter === 'mutuelleonline_affiliation'"
  >
    <div class="wave-container">
      <img
        src="../../../../../../assets/img/wave.svg"
        alt=""
        srcset=""
        class="wave"
      />
    </div>
    <div class="footer-mutuelle-com__content">
      <div class="footer-mutuelle-com__content__first">
        <p>
          <strong>Mutuelle Online </strong>est une marque exploitée par
          <strong>AFI Assurances&nbsp;</strong
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >(</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >société d<b>u Groupe Meilleurtaux</b>) –</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >&nbsp;</span
          ><span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >SAS au capital de 10 000€ –&nbsp;</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >12 rue du Bois Guillaume <br />– 91055 Evry Courcouronnes Cedex –
            RCS Evry 404 414 583&nbsp;</span
          >
        </p>
        <p>
          <span
            style="
              font-size: 14px;
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
            "
            >Courtier en assurance ORIAS n°</span
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;07 027 969 (</span
          ><a
            href="https://www.orias.fr/"
            target="_blank"
            rel="noopener"
            class="link"
            >www.orias.fr)</a
          ><span
            style="
              font-family:
                var(--e-global-typography-text-font-family), Sans-serif;
              font-size: 14px;
            "
            >&nbsp;soumise au contrôle de l’ACPR (Autorité de Contrôle
            Prudentiel et de Résolution – 4 place de Budapest, CS 75 436 Paris
            Cedex 09)</span
          >
        </p>
      </div>
      <div class="footer-mutuelle-com__content__second">
        <p>
          <em><sup>1</sup></em
          ><em
            >&nbsp;Montant moyen économisé par les clients du produit de
            complémentaire santé « Evoluo » pour l’année 2023. Etude réalisée du
            01/01/2022 au 31/12/2022 sur un échantillon d’environ 263 personnes
            déjà clientes auprès de Meilleurtaux santé et souhaitant réaliser
            des économies – détail de l’étude disponible sur simple demande à
            l’adresse&nbsp;<a
              href="mailto:dpo-sante@meilleurtaux.com"
              class="link"
              >dpo-sante&#64;meilleurtaux.com</a
            ></em
          >
        </p>
        <p>
          Les informations recueillies dans le formulaire sont enregistrées dans
          un fichier informatisé par&nbsp;<strong>AFI Assurances</strong
          >&nbsp;–&nbsp;La base légale du traitement est le consentement. Les
          données collectées seront communiquées aux seuls destinataires
          suivants : service commercial AFI assurances.&nbsp;Elles sont
          conservées pendant 3 (trois) ans à compter du jour de leur collecte.
        </p>
        <p>
          Vous pouvez accéder aux données vous concernant, les rectifier,
          demander leur effacement ou exercer votre droit à la limitation du
          traitement de vos données. Vous pouvez retirer à tout moment votre
          consentement au traitement de vos données.&nbsp;Vous pouvez également
          vous opposer au traitement de vos données et exercer votre droit à la
          portabilité de vos données.
        </p>
        <p>
          Pour exercer ces droits ou pour toute question sur le traitement de
          vos données dans ce dispositif, vous pouvez contacter notre DPO
          (délégué à la protection des données) :&nbsp;<a
            href="mailto:dpo-afi@afiassurances.fr"
            class="link"
            >dpo-afi&#64;afiassurances.fr</a
          >.&nbsp;
        </p>
        <p>
          Si vous estimez, après nous avoir contactés, que vos droits «
          Informatique et Libertés » ne sont pas respectés, vous pouvez adresser
          une réclamation à la CNIL.&nbsp;Nous vous informons du droit de vous
          inscrire sur la liste d’opposition au démarchage téléphonique
          “Bloctel”, sur laquelle vous pouvez vous inscrire ici :&nbsp;<a
            href="https://conso.bloctel.fr/"
            class="link"
            >https://conso.bloctel.fr.</a
          >
        </p>
      </div>
    </div>
  </div>
</div>

<script
  type="text/javascript"
  src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
  async
></script>

<ng-template #contentNext01>
  <button
    id="nextButton"
    [ngClass]="{
      button_next_1_mobile: true,
      gray: !(personne.compositionFamiliale.length != 0),
      orange: personne.compositionFamiliale.length != 0,
    }"
    [disabled]="!(personne.compositionFamiliale.length != 0)"
    (click)="goNextStep2(curentQuestion)"
    *ngIf="displayBtnQ0"
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNext02>
  <button
    id="nextButton"
    (click)="goNextStep2(curentQuestion)"
    [ngClass]="{
      gray: !(personne.sexe.length != 0),
      orange: personne.sexe.length != 0,
    }"
    [disabled]="!(personne.sexe.length != 0)"
    *ngIf="displayBtnQ1"
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNext03>
  <button
    id="nextButton"
    (click)="goNextStep2(curentQuestion)"
    [ngClass]="{
      gray: !(personne.enfant.nombreEnfants != 0),
      orange: personne.enfant.nombreEnfants != 0,
    }"
    [disabled]="!(personne.enfant.nombreEnfants != 0)"
    style="display: none"
  >
    <!-- <button id="nextButton" (click)="goNextStep()"></button> -->
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextDN>
  <button
    id="nextButton"
    (click)="getInputDate('DateNaissance', personne.dateNaissanceAssure)"
    [ngClass]="{
      contentNextDN: true,
      gray: true,
      orange:
        !dateNaissanceCtrl.hasError('majorPerson') &&
        !dateNaissanceCtrl.hasError('required') &&
        !(CtrlDateNaissance > DateNaissanceMax) &&
        !(CtrlDateNaissance < DateNaissanceMin) &&
        personne.dateNaissanceAssure.length == 10,
    }"
    [disabled]="
      dateNaissanceCtrl.hasError('majorPerson') ||
      dateNaissanceCtrl.hasError('required') ||
      CtrlDateNaissance > DateNaissanceMax ||
      CtrlDateNaissance < DateNaissanceMin ||
      personne.dateNaissanceAssure.length != 10
    "
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextRS>
  <button
    id="nextButton"
    (click)="goNextStep2(curentQuestion)"
    [ngClass]="{
      gray: !(personne.regimeSocial.length != 0),
      orange: personne.regimeSocial.length != 0,
    }"
    [disabled]="!(personne.regimeSocial.length != 0)"
    *ngIf="displayBtnQRS"
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextCDN>
  <button
    id="nextButton"
    (click)="
      getInputDate('ConjointDateNaissance', personne.dateNaissanceConjoint)
    "
    [ngClass]="{
      contentNextCDN: true,
      gray: true,
      orange:
        !dateNaissanceCtrl.hasError('majorPerson') &&
        !dateNaissanceCtrl.hasError('required') &&
        !(CtrlDateNaissance > DateNaissanceMax) &&
        !(CtrlDateNaissance < DateNaissanceMin) &&
        personne.dateNaissanceConjoint.length == 10,
    }"
    [disabled]="
      dateNaissanceCtrl.hasError('majorPerson') ||
      dateNaissanceCtrl.hasError('required') ||
      CtrlDateNaissance > DateNaissanceMax ||
      CtrlDateNaissance < DateNaissanceMin ||
      personne.dateNaissanceConjoint.length != 10
    "
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextCRS>
  <button
    id="nextButton"
    (click)="goNextStep2(curentQuestion)"
    [ngClass]="{
      gray: !(personne.conjointRegimeSociale.length != 0),
      orange: personne.conjointRegimeSociale.length != 0,
    }"
    [disabled]="!(personne.conjointRegimeSociale.length != 0)"
    *ngIf="displayBtnQRSC"
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextDC>
  <button
    id="nextButton"
    (click)="getInputDate('DateDebutContrat', personne.dateDebutContrat)"
    [ngClass]="{
      gray: true,
      orange:
        !dateEffectCtrl.hasError('required') &&
        !(CtrlDateEffet < healthEffectDateMin) &&
        !(CtrlDateEffet > dateEffetMax) &&
        personne.dateDebutContrat.length == 10 &&
        dateEffetValideANI(),
    }"
    [disabled]="
      CtrlDateEffet < healthEffectDateMin ||
      dateEffectCtrl.hasError('required') ||
      CtrlDateEffet > dateEffetMax ||
      personne.dateDebutContrat.length != 10 ||
      !dateEffetValideANI()
    "
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextNivRemb>
  <button
    id="nextButton"
    (click)="setTagNvRemb(); goNextStep2(curentQuestion)"
    [ngClass]="{
      gray:
        !(personne.niveauRemboursement.hospi.length != 0) ||
        !(personne.niveauRemboursement.soinsMedicaux.length != 0) ||
        !(personne.niveauRemboursement.dentaire.length != 0) ||
        !(personne.niveauRemboursement.optique.length != 0) ||
        !(personne.niveauRemboursement.auditive.length != 0),
      orange:
        personne.niveauRemboursement.hospi.length != 0 &&
        personne.niveauRemboursement.soinsMedicaux.length != 0 &&
        personne.niveauRemboursement.dentaire.length != 0 &&
        personne.niveauRemboursement.optique.length != 0 &&
        personne.niveauRemboursement.auditive.length != 0,
    }"
    [disabled]="
      !(personne.niveauRemboursement.hospi.length != 0) ||
      !(personne.niveauRemboursement.soinsMedicaux.length != 0) ||
      !(personne.niveauRemboursement.dentaire.length != 0) ||
      !(personne.niveauRemboursement.optique.length != 0) ||
      !(personne.niveauRemboursement.auditive.length != 0)
    "
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextNomPrenom>
  <button
    id="nextButton"
    style="white-space: nowrap; width: auto"
    (click)="getInputNomPrenomValue('NomPrenom', personne.nom, personne.prenom)"
    [ngClass]="{
      orange:
        !loading &&
        !nomCtrl.hasError('required') &&
        !nomCtrl.hasError('pattern') &&
        !prenomCtrl.hasError('required') &&
        !prenomCtrl.hasError('pattern'),
      gray:
        loading ||
        nomCtrl.hasError('required') ||
        nomCtrl.hasError('pattern') ||
        prenomCtrl.hasError('required') ||
        prenomCtrl.hasError('pattern'),
    }"
    [disabled]="
      loading ||
      nomCtrl.hasError('required') ||
      nomCtrl.hasError('pattern') ||
      prenomCtrl.hasError('required') ||
      prenomCtrl.hasError('pattern')
    "
  >
    <div *ngIf="loading" class="spinner-border text-light" role="status">
      <span class="sr-only">Traitement...</span>
    </div>
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>

<ng-template #contentNextDep>
  <button
    id="nextButton"
    (click)="setTagAdresse(); goNextStep2(curentQuestion)"
    [ngClass]="{
      orange:
        personne.codePostal.length == 5 && !codePostalCtrl.hasError('pattern'),
      gray: true,
    }"
    [disabled]="
      personne.codePostal.length < 5 || codePostalCtrl.hasError('pattern')
    "
  >
    Suivant
    <img src="assets/img/next.svg" alt="" />
  </button>
</ng-template>
